import React, { useContext, useEffect, useState, useRef, useCallback } from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment-timezone';
import { useDispatch, useSelector } from 'react-redux';
import { activeServices, activeServicio, unactiveServicio } from '../../../actions/servicios';
import { openModalBottom, setDarkHeader } from '../../../actions/ui';
import { fetchAvailableSlots, getProfesionales, getProfesionalesDisabled, getSucursales } from '../../../helpers/horarios';
import { activeCita, getCita, getCitas, refreshCita, startNewCita, startSaveCita, startSaveComentariosCita, startCambiarProfesionalServicio, unactiveCita } from '../../../actions/citas';
import { DropdownServicios } from '../../../components/forms/DropdownServicios';
import { DropdownMultipleServicios } from '../../../components/forms/DropdownMultipleServicios';
import { DropdownSucursales } from '../../../components/forms/DropdownSucursales';
import { DropdownProfesionales } from '../../../components/forms/DropdownProfesionales';
import { MultiSelectionVariantes } from '../../../components/forms/MultiSelectionVariantes';
import { DropdownDate } from '../../../components/forms/DropdownDate';
import { DropdownTime } from '../../../components/forms/DropdownTime';
import { HorarioSelect } from '../../../components/tools/HorarioSelect';
import { DropdownClientes } from '../../../components/forms/DropdownClientes';
import { activeUsuario, unactiveUsuario, usuarioLogout } from '../../../actions/usuarios';
import { unactiveProfesional } from '../../../actions/profesionales';
import { unactiveSucursal } from '../../../actions/sucursales';
import { SocketContext } from '../../../context/SocketContext';
import { AlertasIcon, CheckIcon, ClientesIcon, ClockAlertIcon, CloseIcon,
         CommentsFilledIcon, DelayIcon, EditarIcon, EuroIcon, FingerDownIcon,
         FingerUpIcon, MailIcon, ObservacionesIcon, PagoAdelantadoIcon, PreciosEspecialesIcon,
         ProfesionalesIcon, RandomIcon, ReservasIcon, ServiciosIcon, SucursalesIcon,
         TelephoneIcon, TrashIcon, VariantesIcon, CreditCardIcon } from '../../../assets/svg/iconos';
import { DropdownPromociones } from '../../../components/forms/DropdownPromociones';
import { startLoadingSucursales } from '../../../actions/sucursales';
import { startLoadingServicios } from '../../../actions/servicios';
import { startLoadingProfesionales } from '../../../actions/profesionales';
import { startLoadingHorarios } from '../../../actions/horarios';
import { startLoadingPromociones } from '../../../actions/promociones';
import { startLoadingProductos } from '../../../actions/productos';
import { startEnviarTicketVenta } from '../../../actions/ventas';
import { fetchConToken } from '../../../helpers/fetch';
import { calcularDescuentoServicioCentimos } from '../../../helpers/descuentoServicio';
import { calcularImporteAplicadoEuros } from '../../../helpers/importeAplicado';
import { isProfesionalEnVacacionesOAusencia } from '../helpers/helpersReservas';
import Swal from 'sweetalert2';
import {
    serviciosCitaParaUI,
    variantesCitaParaUI,
    resolverServicioEnCita,
    nombreServicioDesdeDetalle,
    nombreVarianteParaDisplay,
} from '../../../helpers/citaVentaSnapshots';

// const timezone = process.env.REACT_APP_TIMEZONE;
const usarSockets = process.env.REACT_SOCKETS === 'true';

const METODOS_PAGO = [
    { id: "Pago Tarjeta App", nombre: "Pago Tarjeta App" },
    { id: "Pago Tarjeta Sucursal", nombre: "Pago Tarjeta Sucursal" },
    { id: "Monedero Sucursal", nombre: "Monedero Sucursal" },
    { id: "Monedero App", nombre: "Monedero App" },
    { id: "Pago en sucursal App", nombre: "Pago en sucursal App" },
    { id: "Pago en efectivo", nombre: "Pago en efectivo" },
];

export const ModalReserva = ({ history, citaActive: citaActiveProp, activeModalReserva, 
    setActiveModalReserva, setActiveModalDeleteCita, setEstadoCita, editCita, 
    setEditCita, setDataModal, modalResponse, setModalResponse,     setModalTwoButtonsOpened, setActiveModalVentas = () => {}, setVentaModoCitaCompleta = () => {},
    modalWaiting, setModalWaiting, fromGestion = true, deleteCita = null, fromCliente = false, 
    usuarioActive = {}, selectedDate, viewValue = 'day', previousSelectedDate }) => {
    const dispatch = useDispatch();
    const { uid, empresa } = useSelector(state => state.auth);
    const { colores } = useSelector(state => state.ui);
    const { usuarios, active: usuarioActivo } = useSelector(state => state.usuarios);
    const { servicios, active: servicioActive } = useSelector(state => state.servicios);
    const { vacaciones } = useSelector(state => state.vacaciones);
    const { empresas } = useSelector(state => state.empresas);
    const { sucursales: rdSucursales, active: sucursalActive } = useSelector(state => state.sucursales);
    const { profesionales: rdProfesionales, active: profesionalActive } = useSelector(state => state.profesionales);
    const { horarios } = useSelector(state => state.horarios);
    const { citas, active: citaActiva } = useSelector(state => state.citas);
    const { promociones } = useSelector(state => state.promociones);
    const { variantes } = useSelector(state => state.variantes);

    const mismaCitaId = citaActiveProp?._id && citaActiva?._id && String(citaActiveProp._id) === String(citaActiva._id);
    const citaActive = mismaCitaId ? citaActiva : (citaActiveProp !== undefined ? citaActiveProp : citaActiva);
    const mismoUsuarioId = usuarioActive?._id && usuarioActivo?._id && String(usuarioActive._id) === String(usuarioActivo._id);
    const usuarioActivoResolved = mismoUsuarioId ? usuarioActivo : (editCita && usuarioActivo == null ? usuarioActive : usuarioActivo);

    const [descuentosHorario, setDescuentosHorario] = useState(0);
    const [intervaloTiempo, setIntervaloTiempo] = useState(5);
    const [ordenSeleccion, setOrdenSeleccion] = useState([]);
    const [formErrores, setFormErrores] = useState({});
    const { socket } = useContext(SocketContext);
    const [hasAlertas, setHasAlertas] = useState(false);
    const [alertasActive, setAlertasActive] = useState(false);
    const [firstProfesional, setFirstProfesional] = useState('');
    const [enviandoTicket, setEnviandoTicket] = useState(false);
    const [isCreatingCita, setIsCreatingCita] = useState(false);

    const getInitials = (nombre) => {
        if (!nombre) return '?';
        const parts = String(nombre).trim().split(/\s+/);
        if (parts.length >= 2) return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
        return String(nombre).substring(0, 2).toUpperCase();
    };

    const [registerFormOk, setRegisterFormOk] = useState(false);

    const [selectUsuario, setSelectUsuario] = useState({
        selected: null,
        visible: true,
        active: false,
    });
    const [selectServicio, setSelectServicio] = useState({
        selected: null,
        visible: true,
        active: false,
    });
    const [selectSucursal, setSelectSucursal] = useState({
        selected: null,
        visible: false,
        active: false,
    });
    const [selectProfesional, setSelectProfesional] = useState({
        selected: null,
        visible: false,
        active: false,
        cambiado: (fromGestion) ? true : false
    });
    const [selectDate, setSelectDate] = useState({
        date: new Date(),
        visible: false,
        active: false,
    });
    const [selectTime, setSelectTime] = useState({
        date: new Date(),
        visible: false,
        active: false,
        touched: false
    });
    const [selectPromocion, setSelectPromocion] = useState({
        promociones: [],
        visible: false,
        active: false
    });
    const [selectedServices, setSelectedServices] = useState([]);
    const [filteredServices, setFilteredServices] = useState([]);
    const [selectedVariantes, setSelectedVariantes] = useState([]);
    const [profesionalesPorServicio, setProfesionalesPorServicio] = useState({});
    const [profesionalesDropdowns, setProfesionalesDropdowns] = useState({});
    const profesionalesDropdownsRefs = useRef({});

    const [fechaCalendar, setFechaCalendar] = useState(new Date());
    const [timeCalendar, setTimeCalendar] = useState(new Date(1972, 10, 13, 0, 0));
    const [profSelected, setProfSelected] = useState('');
    const PROFESIONAL_ALEATORIO_ID = '333';
    const PROFESIONAL_ALEATORIO_KEYWORD = 'random';
    const esIdProfesionalAleatorio = (profesionalId) => String(profesionalId) === PROFESIONAL_ALEATORIO_ID;
    const esProfesionalAleatorioEnSlot = (profesionalId) =>
        profesionalId === PROFESIONAL_ALEATORIO_KEYWORD || esIdProfesionalAleatorio(profesionalId);
    const calcularSeleccionAleatoria = ({
        cantidadServicios,
        horariosSolicitadosConAleatorio,
        profesionalSeleccionadoId,
        esEdicionMismoProfesional,
        citaActivaEsAleatoria
    }) => {
        if (cantidadServicios !== 1) return false;
        if (esEdicionMismoProfesional) return citaActivaEsAleatoria === true;
        const esAleatorioPorRef = horariosSolicitadosConAleatorio;
        const esAleatorioPorDropdown = esIdProfesionalAleatorio(profesionalSeleccionadoId);
        return esAleatorioPorRef || esAleatorioPorDropdown;
    };
    // EX-428: ref para recordar si los horarios actuales se pidieron con profesional "aleatorio" (333)
    const horariosEranAleatorioRef = useRef(false);

    const [sucursales, setSucursales] = useState([]);
    const [profesionales, setProfesionales] = useState([]);
    const [profesionalesDisabled, setProfesionalesDisabled] = useState([]);
    const [promocionesFiltradas, setPromocionesFiltradas] = useState([]);

    const [morning, setMorning] = useState([]);
    const [afternoon, setAfternoon] = useState([]);
    const [isLoadingAvailability, setIsLoadingAvailability] = useState(false);
    const [hasAttemptedAvailability, setHasAttemptedAvailability] = useState(false);

    const [morningPorServicio, setMorningPorServicio] = useState({});
    const [timeCalendarPorServicio, setTimeCalendarPorServicio] = useState({});
    const [isLoadingSlotsPorServicio, setIsLoadingSlotsPorServicio] = useState({});
    const [selectTimePorServicio, setSelectTimePorServicio] = useState({});
    const [profesionalPorServicioSlot, setProfesionalPorServicioSlot] = useState({});
    const [profesionalesPorServicioLista, setProfesionalesPorServicioLista] = useState({});
    const [mostrarSelectorPrimerServicio, setMostrarSelectorPrimerServicio] = useState(false);

    const [txtComentario, setTxtComentario] = useState('');
    const [comentariosCita, setComentariosCita] = useState([]);
    const [telefonoReserva, setTelefonoReserva] = useState('');
    const [comentariosRespondidos, setComentariosRespondidos] = useState(false);
    const [grabaComentarios, setGrabaComentarios] = useState(false);
    const [respuestaAutomatica, setRespuestaAutomatica] = useState(true);
    const [editActive, setEditActive] = useState(false);
    const [editNotesOnly, setEditNotesOnly] = useState(false);

    useEffect(() => {
        if (servicioActive) {
            handleServicioSelected(servicioActive);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (empresas[0]) {
            //setIntervaloTiempo(parseInt(empresas[0].intervaloTiempo));
            setOrdenSeleccion(empresas[0].ordenSeleccion);
        }
    }, [empresas]);

    useEffect(() => {	
        if (citaActive) {
            let conAlertas = false;
            if (citaActive?.usuarioDelay !== "0") { conAlertas = true; }
            const delayProfSlot = (citaActive?.servicioActual?.profesionalDelay != null && citaActive.servicioActual.profesionalDelay !== '') ? citaActive.servicioActual.profesionalDelay : citaActive?.profesionalDelay;
            if (delayProfSlot !== "0" && delayProfSlot != null && String(delayProfSlot).trim() !== "") { conAlertas = true; }
            if (citaActive?.pagada) { conAlertas = true; }
            if (citaActive?.comentarios?.length > 0) { conAlertas = true; }
            if (usuarioActivoResolved?.comentarios?.length > 0) { conAlertas = true; }
            setHasAlertas(conAlertas);
        }
        if (citaActive && citaActive?.comentarios?.length > 0) {
            let comentariosAFiltrar = citaActive.comentarios;
            if (editCita && citaActive?.servicios?.length > 1 && citaActive?.servicioActual) {
                const idxServ = citaActive.idxServicio !== undefined && citaActive.idxServicio >= 0
                    ? citaActive.idxServicio
                    : citaActive.servicios?.findIndex(sd => {
                        const sdId = sd.servicio?._id || sd.servicio;
                        const actualId = citaActive.servicioActual.servicio?._id || citaActive.servicioActual.servicio;
                        return String(sdId) === String(actualId);
                    });
                if (idxServ >= 0) {
                    comentariosAFiltrar = citaActive.comentarios.filter(c => 
                        c.idxServicio === idxServ || (c.idxServicio == null && idxServ === 0)
                    );
                }
            }
            const comentarioInicial = comentariosAFiltrar.find(comentario => !comentario.business);
            if (comentarioInicial) {
                setTxtComentario(comentarioInicial.texto);
            } else {
                setTxtComentario('');
            }
            if (comentariosAFiltrar?.length > 0 && comentariosAFiltrar[comentariosAFiltrar.length - 1]?.business === true) {
                setComentariosRespondidos(true);
            } else {
                setComentariosRespondidos(false);
            }
            setComentariosCita([...comentariosAFiltrar]);
        } else if (citaActive) {
            setTxtComentario('');
            setComentariosCita([]);
            setComentariosRespondidos(false);
        }
    }, [citaActive, usuarioActivoResolved]);

    useEffect(() => {
        const esEdicionServicioEspecifico = editCita && 
                                           citaActive?.servicioActual && 
                                           citaActive.servicios && 
                                           citaActive.servicios.length > 1 &&
                                           citaActive?.servicios?.length > 1;
        
        if (esEdicionServicioEspecifico) {
            const servicioActual = citaActive.servicioActual;
            const servicioIdActual = servicioActual.servicio?._id || servicioActual.servicio;
            const servicioParaEditar = resolverServicioEnCita(citaActive, servicioIdActual, servicios)
                || citaActive.servicios?.find(referenciaServicio => {
                if (!referenciaServicio) return false;
                const servicioIdReferencia = referenciaServicio._id || referenciaServicio;
                return String(servicioIdReferencia) === String(servicioIdActual);
            });
            
            if (servicioParaEditar && citaActive.variantes && Array.isArray(citaActive.variantes)) {
                const servicioIdEditando = servicioParaEditar._id || servicioParaEditar;
                const variantesDelServicioActual = variantesCitaParaUI(citaActive, variantes, servicioIdEditando);

                handleVariantesChanged(variantesDelServicioActual);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [citaActive?.variantes, citaActive?.servicioActual, editCita]);

    useEffect(() => {
        if (grabaComentarios) {
            setGrabaComentarios(false);
            clickReservar(true);
            dispatch(openModalBottom({ text: ['Comentarios guardados correctamente'], timeOut: 3 }));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [grabaComentarios]);

    useEffect(() => {
        if (editCita) {

            let servicioParaEditar = null;
            let profesionalParaEditar = null;
            let variantesParaEditar = [];
            let fechaInicioServicio = null;
            
            if (citaActive?.servicioActual) {
                const servicioActual = citaActive.servicioActual;
                const servicioIdActual = servicioActual.servicio?._id || servicioActual.servicio;
                servicioParaEditar = resolverServicioEnCita(citaActive, servicioIdActual, servicios)
                    || citaActive.servicios?.find(referenciaServicio => {
                    if (!referenciaServicio) return false;
                    const servicioIdReferencia = referenciaServicio._id || referenciaServicio;
                    return String(servicioIdReferencia) === String(servicioIdActual);
                });
                
                const profesionalIdActual = servicioActual.profesional?._id || servicioActual.profesional;
                profesionalParaEditar = rdProfesionales.find(p => p && p._id && String(p._id) === String(profesionalIdActual));
                
                fechaInicioServicio = servicioActual.fechaInicio ? moment(servicioActual.fechaInicio) : moment(citaActive.fecha);
                
                if (citaActive.variantes && citaActive.variantes.length > 0 && servicioParaEditar) {
                    const servicioIdEditando = servicioParaEditar._id || servicioParaEditar;
                    variantesParaEditar = variantesCitaParaUI(citaActive, variantes, servicioIdEditando);
                }
            }
            
            if (servicioActive) {
                if(citaActive){
                    if (citaActive.servicios && citaActive.servicios.length > 0) {
                        setSelectedServices(serviciosCitaParaUI(citaActive, servicios));
                    } else if (citaActive.servicio) {
                        setSelectedServices([citaActive.servicio]);
                    }
                    
                    if (citaActive.servicios && citaActive.servicios.length > 0) {
                        const profesionalesPorServicioObj = {};
                        citaActive.servicios.forEach((servicioDetalle) => {
                            const servicioId = servicioDetalle.servicio?._id || servicioDetalle.servicio;
                            const profesionalId = servicioDetalle.profesional?._id || servicioDetalle.profesional;
                            if (servicioId && profesionalId) {
                                if (citaActive.servicios.length > 1) {
                                    profesionalesPorServicioObj[servicioId] = profesionalId;
                                } else if (profesionalId !== citaActive.profesional?._id) {
                                    profesionalesPorServicioObj[servicioId] = profesionalId;
                                }
                            }
                        });
                        setProfesionalesPorServicio(profesionalesPorServicioObj);
                    }
                    
                    if (servicioParaEditar && profesionalParaEditar) {
                        handleServicioSelected(servicioParaEditar);
                        handleVariantesChanged(variantesParaEditar);
                        handleSucursalSelected(sucursalActive);
                        setFirstProfesional(profesionalParaEditar._id);
                        handleProfesionalSelected(profesionalParaEditar);
                    } else {
                        handleServicioSelected(servicioActive);
                        handleVariantesChanged(getVariantes(citaActive));
                        handleSucursalSelected(sucursalActive);
                        setFirstProfesional(profesionalActive._id);
                        handleProfesionalSelected(profesionalActive);
                    }
                    
                    const fechaParaUsar = fechaInicioServicio ? fechaInicioServicio.toDate() : new Date(citaActive.fecha);
                    setSelectDate({ ...selectDate, visible: true, date: fechaParaUsar });
                    setFechaCalendar(fechaParaUsar);
                    setSelectTime({ ...selectTime, visible: true, date: fechaParaUsar, touched: true });
                    setTimeCalendar(fechaParaUsar);
                    recalculaPromociones();
                }
            } else {
                if(citaActive){
                    if (citaActive.servicios && citaActive.servicios.length > 0) {
                        setSelectedServices(serviciosCitaParaUI(citaActive, servicios));
                    } else if (citaActive.servicio) {
                        setSelectedServices([citaActive.servicio]);
                    }
                    
                    if (citaActive.servicios && citaActive.servicios.length > 0) {
                        const profesionalesPorServicioObj = {};
                        citaActive.servicios.forEach((servicioDetalle) => {
                            const servicioId = servicioDetalle.servicio?._id || servicioDetalle.servicio;
                            const profesionalId = servicioDetalle.profesional?._id || servicioDetalle.profesional;
                            if (servicioId && profesionalId) {
                                if (citaActive.servicios.length > 1) {
                                    profesionalesPorServicioObj[servicioId] = profesionalId;
                                } else if (profesionalId !== citaActive.profesional?._id) {
                                    profesionalesPorServicioObj[servicioId] = profesionalId;
                                }
                            }
                        });
                        setProfesionalesPorServicio(profesionalesPorServicioObj);
                    }
                    
                    if (servicioParaEditar && profesionalParaEditar) {
                        handleServicioSelected(servicioParaEditar);
                        handleVariantesChanged(variantesParaEditar);
                        handleSucursalSelected(citaActive.sucursal);
                        setFirstProfesional(profesionalParaEditar._id);
                        handleProfesionalSelected(profesionalParaEditar);
                    } else {
                        const primerServicio = citaActive.servicios?.[0];
                        const servicioId = primerServicio && (primerServicio._id || primerServicio);
                        const servicioResuelto = servicioId && servicios?.length
                            ? servicios.find(s => String(s._id || s) === String(servicioId)) || primerServicio
                            : primerServicio;
                        handleServicioSelected(servicioResuelto);
                        handleVariantesChanged(getVariantes(citaActive));
                        handleSucursalSelected(citaActive.sucursal);
                        const profesionalInicial = citaActive.servicioActual?.profesional != null
                            ? (typeof citaActive.servicioActual.profesional === 'object' && citaActive.servicioActual.profesional?.nombre
                                ? citaActive.servicioActual.profesional
                                : rdProfesionales.find(p => p && (String(p._id) === String(citaActive.servicioActual.profesional?._id || citaActive.servicioActual.profesional))))
                            : citaActive.profesional;
                        const profId = profesionalInicial?._id || profesionalInicial;
                        if (profId) {
                            setFirstProfesional(profId);
                            handleProfesionalSelected(profesionalInicial);
                        } else {
                            setFirstProfesional(citaActive.profesional?._id);
                            handleProfesionalSelected(citaActive.profesional);
                        }
                    }
                    
                    const fechaParaUsar = fechaInicioServicio ? fechaInicioServicio.toDate() : new Date(citaActive.fecha);
                    setSelectDate({ ...selectDate, visible: true, date: fechaParaUsar });
                    setFechaCalendar(fechaParaUsar);
                    setSelectTime({ ...selectTime, visible: true, date: fechaParaUsar, touched: true });
                    setTimeCalendar(fechaParaUsar);
                    recalculaPromociones();
                }
            }
        } else {
            const promocionesValidas = promociones.filter(promo => moment(promo.fechaInicio).isSameOrBefore(moment()) && moment(promo.caducidad).isSameOrAfter(moment()));
            promocionesValidas.forEach(item => {
                item.selected = false;
            });
            setPromocionesFiltradas(promocionesValidas);
            setSelectPromocion({
                promociones: [],
                visible: false,
                active: false
            });
            //setSelectDate({ ...selectDate, visible: true, date: selectedDate });
            //console.log("selectedDate: ", selectedDate);
            //console.log("selectDate: ", selectDate);
        }

        //setSelectedVariantes(citaActive?.variantes ?? [])

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [editCita, promociones, citaActive]);

    useEffect(() => {
        if (usuarioActivoResolved) {
            setSelectUsuario({
                _id: usuarioActivoResolved._id,
                selected: usuarioActivoResolved,
                visible: true,
                active: false
            });
            setTelefonoReserva(usuarioActivoResolved?.telefono || '');
        }
    }, [usuarioActivoResolved]);

    useEffect(() => {
        if (activeModalReserva && !editCita && fromCliente && usuarioActive && usuarioActive._id) {
            dispatch(activeUsuario(usuarioActive._id, usuarioActive));
            setSelectUsuario({
                _id: usuarioActive._id,
                selected: usuarioActive,
                visible: true,
                active: false
            });
            setSelectServicio({ selected: null, visible: true, active: false });
            setSelectSucursal({ selected: null, visible: false, active: false });
            setSelectProfesional({ selected: null, visible: false, active: false, cambiado: false });
            setSelectDate({ date: new Date(), visible: false, active: false });
            setSelectTime({ date: new Date(1972, 10, 13, 0, 0), visible: false, active: false, touched: false });
            setSelectedServices([]);
            setSelectedVariantes([]);
            setProfesionalesPorServicio({});
            setFechaCalendar(new Date());
            setTimeCalendar(new Date(1972, 10, 13, 0, 0));
            setFirstProfesional('');
            setTxtComentario('');
            setComentariosCita([]);
            setComentariosRespondidos(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [activeModalReserva, editCita, fromCliente]);

    useEffect(() => {
        if (activeModalReserva && editCita && citaActive?.servicios?.length > 1 && !citaActive.servicioActual && empresa && citaActive._id) {
            const primeroNoPagado = citaActive.servicios.find(sd => !sd.pagada);
            const detalleAMostrar = primeroNoPagado || citaActive.servicios[0];
            if (detalleAMostrar) {
                dispatch(getCita(citaActive._id, empresa, { servicioActual: detalleAMostrar }));
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [activeModalReserva, editCita, citaActive?._id, empresa]);

    useEffect(() => {
        dispatch(setDarkHeader(true));
    }, [dispatch]);

    useEffect(() => {
        recalculaPromociones();
        getMorningAfternoon();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectProfesional.selected, fechaCalendar, profesionales, selectedVariantes, selectServicio.selected, profesionalesPorServicio, selectSucursal.selected]);

    useEffect(() => {
        if (selectedServices && selectSucursal.selected && selectedServices.length > 0) {
            getProfesionales(selectedServices, selectSucursal.selected, promociones, rdProfesionales, rdSucursales)
                .then(result => {
                    if (result && Array.isArray(result)) {
                        const sucursalId = selectSucursal.selected?._id;
                        const fechaDay = fechaCalendar;
                        let disponibles = result;
                        let enVacaciones = [];
                        if (fechaDay && vacaciones && vacaciones.length > 0) {
                            enVacaciones = result.filter(p => isProfesionalEnVacacionesOAusencia(p, fechaDay, vacaciones, sucursalId));
                            disponibles = result.filter(p => !isProfesionalEnVacacionesOAusencia(p, fechaDay, vacaciones, sucursalId));
                        }
                        setProfesionales(disponibles);
                        if (result.length > 1) {
                            getProfesionalesDisabled(rdProfesionales, result).then(profesionalsDisabled => {
                                const otrosDisabled = profesionalsDisabled || [];
                                setProfesionalesDisabled([...otrosDisabled, ...enVacaciones]);
                            }).catch(error => {
                                console.error('Error getting disabled professionals:', error);
                                setProfesionalesDisabled(enVacaciones);
                            });
                        } else {
                            if (result.length === 1) handleProfesionalSelected(disponibles[0] || result[0]);
                        }
                    }
                }).catch(error => {
                    console.error('Error getting professionals:', error);
                    setProfesionales([]);
                });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectSucursal.selected, fechaCalendar, vacaciones]);

    useEffect(() => {
        setPromocionesFiltradas(promociones);
    }, [promociones]);


    useEffect(() => {
        let errores = false;

        if (!usuarioActivoResolved) {
            errores = true;
        }
        if (!selectServicio.selected) {
            errores = true;
        }
        if (!selectSucursal.selected) {
            errores = true;
        }
        if (!selectProfesional.selected) {
            errores = true;
        }
        if (timeCalendar.toISOString() === '1972-11-12T23:00:00.000Z') {
            errores = true;
        }

        setRegisterFormOk(errores);

    }, [usuarioActivoResolved, selectServicio, selectSucursal, selectProfesional, timeCalendar]);

    useEffect(() => {
        if (selectTime.touched) {
            recalculaPromociones();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectTime]);
    
    useEffect(() => {
        if (editCita && modalWaiting?._id) {
            if (modalResponse === 1) {
                dispatch(startSaveCita(modalWaiting)).then(() => {
                    setModalResponse(100);
					setSelectedServices([]);
                    if(fromCliente)
					    dispatch(activeUsuario(history.location.state.usuario._id, history.location.state.usuario));
                    setModalWaiting({});
                    closeModal(null);
                });
            } else {
                setModalResponse(200);
                setModalWaiting({});
                closeModal(null);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [modalResponse]);

    useEffect(() => {
        if (servicios.length > 0 && selectedServices.length==0) {
            setFilteredServices(servicios);
        }
    }, [servicios, selectedServices]);

    useEffect(() => {
        if (selectedServices.length>0) {
            filterServices();
        }
    }, [selectedServices]);

    useEffect(() => {
      setFechaCalendar(moment(selectedDate).toDate());
    }, [selectedDate])
    
	
	const alertaEdicionCita = () => {		
		dispatch(openModalBottom({ text: ['No se puede editar una cita ya vendida'], timeOut: 3 }));		
	}
    const getVariantes = (cita) => {
        const variantesDesdeSnapshot = variantesCitaParaUI(cita, variantes, undefined);
        if (variantesDesdeSnapshot.length > 0) return variantesDesdeSnapshot;
        if (!cita?.variantes || !Array.isArray(cita.variantes) || !variantes?.length) return [];
        const referenciasVariantes = [cita.variantes].flat();
        const idsServiciosCita = (cita.servicios && [cita.servicios].flat().length > 0)
            ? [cita.servicios].flat().map(referenciaServicio => String(referenciaServicio._id || referenciaServicio))
            : [];
        const variantesResueltasDesdeRedux = referenciasVariantes
            .map(referenciaVariante => {
                const varianteId = referenciaVariante && (referenciaVariante._id || referenciaVariante);
                if (!varianteId) return null;
                return variantes.find(itemVariante => String(itemVariante._id || itemVariante) === String(varianteId));
            })
            .filter(Boolean);
        if (idsServiciosCita.length === 0) return variantesResueltasDesdeRedux;
        return variantesResueltasDesdeRedux.filter(itemVariante =>
            (itemVariante.servicios || []).some(idServicioAsociado =>
                idsServiciosCita.includes(String(idServicioAsociado?._id || idServicioAsociado))
            )
        );
    }

    const filterServices = () => {
        let selectedServicesTotal = [];
        if (selectedServices.length) {
            selectedServicesTotal = [
                ...selectedServices
            ];

            if(selectedServicesTotal[selectedServices.length - 1].complementarios){
                selectedServicesTotal[selectedServices.length - 1].complementarios.forEach(complementario => {
                    const newService = getServicio(complementario);
                    
                    if (!newService) return;
                    
                    if (selectedServicesTotal.some(service => {
                        if (!service._id || !newService._id) return false;
                        return String(service._id) === String(newService._id);
                    })) return;
                    
                    selectedServicesTotal = [
                        ...selectedServicesTotal,
                        newService
                    ]
                });
            }
        }

        setFilteredServices(selectedServicesTotal);
    };

    const getMorningAfternoon = async () => {
        setIsLoadingAvailability(true);
        setHasAttemptedAvailability(false);
        // Sumar Duración de los servicios seleccionados.
        const sumaDuracion = selectedServices.reduce((total, service) => {
                            return total + parseInt(service.duracion, 10);
                         }, 0);
        const servicesIds = selectedServices.flatMap(service => service._id);
        const variantesTiempoPorServicio = (servicioId) => selectedVariantes
            .filter(v => v && Array.isArray(v.servicios) && v.servicios.some(sId => String(sId?._id || sId) === String(servicioId)))
            .reduce((acc, v) => acc + parseInt(v.tiempo || 0, 10), 0);
        let variantes = selectedServices.length === 1
            ? variantesTiempoPorServicio(selectedServices[0]._id)
            : selectedServices.reduce((acc, s) => acc + variantesTiempoPorServicio(s._id), 0);
        if (isNaN(variantes)) variantes = 0;

        let profesionalParaHorarios = selectProfesional.selected;
        let requiereProfesional = selectedServices.length === 1;
        
        if (requiereProfesional && !profesionalParaHorarios && selectedServices.length > 0) {
            const primerServicio = selectedServices[0];
            const profesionalIdPorServicio = profesionalesPorServicio[primerServicio._id];
            if (profesionalIdPorServicio) {
                profesionalParaHorarios = profesionales.find(p => p._id === profesionalIdPorServicio);
            }
        }

        const puedeCalcular = selectedServices.length > 1 
            ? selectSucursal.selected 
            : (profesionalParaHorarios && selectSucursal.selected);

        if (puedeCalcular) {
            let fetchAttempted = false;
            
            try {
                let serviciosParaEnviar = null;
                
                if (selectedServices.length > 1) {
                    const primerServicio = selectedServices[0];
                    const profesionalPrimerServicio = profesionalesPorServicio[primerServicio._id];
                    
                    if (!profesionalPrimerServicio) {
                        setMorning([]);
                        setAfternoon([]);
                        setIsLoadingAvailability(false);
                        setHasAttemptedAvailability(false);
                        return;
                    }
                    
                    const serviciosSinProfesional = selectedServices.slice(1).filter(servicio => 
                        !profesionalesPorServicio[servicio._id]
                    );
                    
                    if (serviciosSinProfesional.length === 0) {
                        const toRandom = (id) => (id === '333' || id === 333) ? 'random' : id;
                        serviciosParaEnviar = selectedServices.map((servicio) => {
                            const profesionalId = profesionalesPorServicio[servicio._id];
                            let duracionServicio = parseInt(servicio.duracion || 0);
                            
                            if (selectedVariantes.length > 0) {
                                const tiempoVariantesEsteServicio = selectedVariantes
                                    .filter(v => v && Array.isArray(v.servicios) && v.servicios.some(sId => String(sId?._id || sId) === String(servicio._id)))
                                    .reduce((total, v) => total + parseInt(v.tiempo || 0, 10), 0);
                                duracionServicio += tiempoVariantesEsteServicio;
                            }
                            
                            return {
                                servicio: servicio._id,
                                profesional: toRandom(profesionalId),
                                duracion: duracionServicio
                            };
                        });
                    } else {
                        const duracionPrimero = (primerServicio.duracion1 > 0 && (primerServicio.pausa || 0) >= 0 && primerServicio.duracion2 > 0)
                            ? parseInt(primerServicio.duracion1 || 0) + parseInt(primerServicio.pausa || 0) + parseInt(primerServicio.duracion2 || 0)
                            : parseInt(primerServicio.duracion || 0);
                        serviciosParaEnviar = [{
                            servicio: primerServicio._id,
                            profesional: profesionalPrimerServicio,
                            duracion: duracionPrimero
                        }];
                    }
                }
                
                let profesionalIdParam = "random";
                if (selectedServices.length === 1 && profesionalParaHorarios) {
                    profesionalIdParam = profesionalParaHorarios._id === "333" ? "random" : profesionalParaHorarios._id;
                } else if (selectedServices.length > 1 && serviciosParaEnviar && serviciosParaEnviar.length > 0) {
                    profesionalIdParam = serviciosParaEnviar[0].profesional || "random";
                }
                if (profesionalIdParam === "333" || profesionalIdParam === 333) {
                    profesionalIdParam = "random";
                }

                const esPrimerServicioProfesionalConcreto = selectedServices.length > 1 && (() => {
                    const pid = profesionalesPorServicio[selectedServices[0]._id];
                    return pid && pid !== "333" && pid !== 333;
                })();

                let totalTime;
                let serviciosParam = serviciosParaEnviar;
                let profesionalIdFinal = profesionalIdParam;
                if (esPrimerServicioProfesionalConcreto) {
                    profesionalIdFinal = profesionalesPorServicio[selectedServices[0]._id];
                    totalTime = selectedServices.reduce((acc, service) => {
                        let d = (service.duracion1 > 0 && (service.pausa || 0) >= 0 && service.duracion2 > 0)
                            ? parseInt(service.duracion1 || 0) + parseInt(service.pausa || 0) + parseInt(service.duracion2 || 0)
                            : parseInt(service.duracion || 0, 10);
                        d += variantesTiempoPorServicio(service._id);
                        return acc + d;
                    }, 0);
                    serviciosParam = null;
                } else {
                    totalTime = serviciosParaEnviar && serviciosParaEnviar.length > 0
                        ? serviciosParaEnviar.reduce((acc, s) => acc + (s.duracion || 0), 0)
                        : sumaDuracion + variantes;
                }

                const params = {
                    month: fechaCalendar.getMonth(),
                    year: fechaCalendar.getFullYear(),
                    empresa,
                    profesionalId: profesionalIdFinal,
                    sucursalId: selectSucursal.selected._id,
                    sucursales: rdSucursales,
                    serviciosId: servicesIds,
                    totalTime,
                    intervaloTiempo,
                    citaIdExcluir: citaActive?._id,
                    servicios: serviciosParam,
                    usuarioId: selectUsuario.selected?._id,
                    variantes: selectedVariantes.map(v => v._id || v)
                }

                fetchAttempted = true;
                horariosEranAleatorioRef.current = (params.profesionalId === 'random');
                const result = await fetchAvailableSlots(params)

                const selectedDay = moment(fechaCalendar).format("YYYY-MM-DD")

                const slots = result[selectedDay]?.map(slot => {
                    const date = moment(slot.start, "hh:mm A");
                    date.date(fechaCalendar.getDate());
                    date.month(fechaCalendar.getMonth());
                    date.year(fechaCalendar.getFullYear());

                    return {
                        available: true,
                        date: date.toDate(),
                        profesional: profesionales.find(p => String(p._id) === String(slot.profesional)),
                        promocion: false
                    }
                }) ?? [];

                setMorning(slots);
                setAfternoon([]);
                if (timeCalendar.getFullYear() !== 1972) {
                    const timeStillInSlots = slots.some(s =>
                        moment(s.date).format('YYYY-MM-DD HH:mm') === moment(timeCalendar).format('YYYY-MM-DD HH:mm')
                    );
                    if (!timeStillInSlots) {
                        setTimeCalendar(new Date(1972, 10, 13, 0, 0));
                    }
                }
            } catch (error) {
                console.error('Error fetching availability:', error);
                setMorning([]);
                setAfternoon([]);
            } finally {
                setIsLoadingAvailability(false);
                setHasAttemptedAvailability(fetchAttempted);
            }
        } else {
            setMorning([]);
            setAfternoon([]);
            setHasAttemptedAvailability(false);
            setIsLoadingAvailability(false);
        }
    }

    const getSlotsRestoProfesionales = useCallback(async () => {
        if (selectedServices.length < 2 || !selectSucursal.selected || !fechaCalendar || moment(timeCalendar).year() === 1972) {
            return;
        }
        const profIdsUnicos = selectedServices.map((s, idx) => {
            const id = profesionalesPorServicio[s._id];
            if (id === '333' || id === 333) return `random_${idx}`;
            return id;
        });
        const profesionalesUnicos = [...new Set(profIdsUnicos.filter(Boolean))];
        if (profesionalesUnicos.length < 2) {
            setMorningPorServicio({});
            return;
        }

        const serviciosResto = selectedServices.slice(1);
        setIsLoadingSlotsPorServicio(prev => serviciosResto.reduce((acc, s) => ({ ...acc, [s._id]: true }), {}));

        try {
            const servicesIds = selectedServices.flatMap(s => s._id);
            const selectedDay = moment(fechaCalendar).format('YYYY-MM-DD');
            let acumuladoMin = 0;
            const primerServicio = selectedServices[0];
            let duracionPrimero = parseInt(primerServicio.duracion || 0);
            const variantesTiempo = (servicioId) => selectedVariantes
                .filter(v => Array.isArray(v?.servicios) && v.servicios.some(sId => String(sId?._id || sId) === String(servicioId)))
                .reduce((t, v) => t + parseInt(v.tiempo || 0, 10), 0);
            duracionPrimero += variantesTiempo(primerServicio._id);
            const profesionalPrimero = profesionales.find(p => p._id === profesionalesPorServicio[primerServicio._id]);
            if (profesionalPrimero?.delay && profesionalPrimero.delay !== '0') {
                if (profesionalPrimero.delayType === 'time') duracionPrimero += parseInt(profesionalPrimero.delay);
                else duracionPrimero += Math.ceil(duracionPrimero * (parseInt(profesionalPrimero.delay) / 100));
            }
            if (usuarioActivoResolved?.delay && usuarioActivoResolved.delay !== '0') {
                if (usuarioActivoResolved.delayType === 'time') duracionPrimero += parseInt(usuarioActivoResolved.delay);
                else duracionPrimero += Math.ceil(duracionPrimero * (parseInt(usuarioActivoResolved.delay) / 100));
            }
            acumuladoMin = duracionPrimero;

            const promises = serviciosResto.map(async (servicio, idx) => {
                const profesionalId = profesionalesPorServicio[servicio._id];
                if (!profesionalId) return { servicioId: servicio._id, slots: [] };
                const profParam = profesionalId === '333' || profesionalId === 333 ? 'random' : profesionalId;
                let dur = parseInt(servicio.duracion || 0) + variantesTiempo(servicio._id);
                const profServicio = profesionales.find(p => p._id === profesionalId);
                if (profServicio?.delay && profServicio.delay !== '0') {
                    if (profServicio.delayType === 'time') dur += parseInt(profServicio.delay);
                    else dur += Math.ceil(dur * (parseInt(profServicio.delay) / 100));
                }
                if (usuarioActivoResolved?.delay && usuarioActivoResolved.delay !== '0') {
                    if (usuarioActivoResolved.delayType === 'time') dur += parseInt(usuarioActivoResolved.delay);
                    else dur += Math.ceil(dur * (parseInt(usuarioActivoResolved.delay) / 100));
                }
                const params = {
                    month: fechaCalendar.getMonth(),
                    year: fechaCalendar.getFullYear(),
                    empresa,
                    profesionalId: profParam,
                    sucursalId: selectSucursal.selected._id,
                    sucursales: rdSucursales,
                    serviciosId: [servicio._id],
                    totalTime: dur,
                    intervaloTiempo,
                    citaIdExcluir: citaActive?._id,
                    servicios: null,
                    usuarioId: selectUsuario.selected?._id,
                    variantes: selectedVariantes.map(v => v._id || v)
                };
                const result = await fetchAvailableSlots(params);
                const slots = (result[selectedDay] || []).map(slot => {
                    const date = moment(slot.start, 'hh:mm A');
                    date.date(fechaCalendar.getDate());
                    date.month(fechaCalendar.getMonth());
                    date.year(fechaCalendar.getFullYear());
                    return {
                        available: true,
                        date: date.toDate(),
                        profesional: slot.profesional ? profesionales.find(p => String(p._id) === String(slot.profesional)) : undefined,
                        promocion: false
                    };
                });
                return { servicioId: servicio._id, slots, acumuladoMin: idx === 0 ? acumuladoMin : null };
            });

            const results = await Promise.all(promises);
            let acumulado = duracionPrimero;
            const newMorning = {};
            const preseleccion = {};
            const newProfesionalPorServicioSlot = {};
            serviciosResto.forEach((servicio, idx) => {
                const r = results[idx];
                if (!r) return;
                const horaMinima = moment(timeCalendar).add(acumulado, 'minutes');
                const slotsTrasPrimera = (r.slots || []).filter((s) => moment(s.date).isSameOrAfter(horaMinima));
                newMorning[r.servicioId] = slotsTrasPrimera;
                const suggested = horaMinima.clone();
                let match = slotsTrasPrimera.find(s => moment(s.date).format('HH:mm') === suggested.format('HH:mm'));
                if (!match && slotsTrasPrimera.length > 0) {
                    const suggestedMin = suggested.hour() * 60 + suggested.minute();
                    const closest = slotsTrasPrimera.reduce((best, s) => {
                        const slotMin = moment(s.date).hour() * 60 + moment(s.date).minute();
                        const diff = Math.abs(slotMin - suggestedMin);
                        if (!best || diff < best.diff) return { slot: s, diff };
                        return best;
                    }, null);
                    match = closest?.slot;
                }
                if (match) preseleccion[r.servicioId] = match.date;
                else if (slotsTrasPrimera.length > 0) preseleccion[r.servicioId] = slotsTrasPrimera[0].date;
                let dur = parseInt(servicio.duracion || 0) + variantesTiempo(servicio._id);
                const profServicio = profesionales.find(p => p._id === profesionalesPorServicio[servicio._id]);
                if (profServicio?.delay && profServicio.delay !== '0') {
                    if (profServicio.delayType === 'time') dur += parseInt(profServicio.delay);
                    else dur += Math.ceil(dur * (parseInt(profServicio.delay) / 100));
                }
                if (usuarioActivoResolved?.delay && usuarioActivoResolved.delay !== '0') {
                    if (usuarioActivoResolved.delayType === 'time') dur += parseInt(usuarioActivoResolved.delay);
                    else dur += Math.ceil(dur * (parseInt(usuarioActivoResolved.delay) / 100));
                }
                acumulado += dur;
            });

            setMorningPorServicio(newMorning);
            setTimeCalendarPorServicio(prev => ({ ...prev, ...preseleccion }));
            const touchedPorServicio = Object.keys(preseleccion).reduce((acc, sid) => ({ ...acc, [sid]: { visible: true, touched: true } }), {});
            setSelectTimePorServicio(prev => ({ ...prev, ...touchedPorServicio }));
        } catch (err) {
            setMorningPorServicio({});
        } finally {
            setIsLoadingSlotsPorServicio({});
        }
    }, [selectedServices, selectSucursal.selected, fechaCalendar, timeCalendar, profesionalesPorServicio, selectedVariantes, citaActive?._id, selectUsuario.selected?._id, empresa, rdSucursales, intervaloTiempo, profesionales, usuarioActivoResolved, profSelected]);

    useEffect(() => {
        if (selectedServices.length > 1 && selectSucursal.selected && timeCalendar && moment(timeCalendar).year() !== 1972) {
            const todosConProfesional = selectedServices.every(s => profesionalesPorServicio[s._id]);
            if (todosConProfesional) {
                setTimeCalendarPorServicio({});
                getSlotsRestoProfesionales();
            } else {
                setMorningPorServicio({});
                setTimeCalendarPorServicio({});
            }
        } else {
            setMorningPorServicio({});
            setTimeCalendarPorServicio({});
        }
    }, [selectedServices, selectSucursal.selected, timeCalendar, profesionalesPorServicio, fechaCalendar, getSlotsRestoProfesionales]);

    useEffect(() => {
        if (selectedServices.length > 1 && selectSucursal.selected) {
            const serviciosSinLista = selectedServices.filter(s => !profesionalesPorServicioLista[s._id]);
            if (serviciosSinLista.length === 0) return;
            (async () => {
                const resultados = await Promise.all(
                    serviciosSinLista.map(servicio =>
                        getProfesionales([servicio], selectSucursal.selected, promociones, rdProfesionales, rdSucursales)
                            .then(lista => ({ servicioId: servicio._id, lista }))
                    )
                );
                setProfesionalesPorServicioLista(prev => {
                    const next = { ...prev };
                    resultados.forEach(({ servicioId, lista }) => { next[servicioId] = lista; });
                    return next;
                });
            })();
        }
    }, [selectedServices, selectSucursal.selected, promociones, rdProfesionales, rdSucursales]);

    const resetForm = () => {
        if (!fromCliente) {
            dispatch(unactiveUsuario());
        }
        dispatch(unactiveServicio());
        setSelectUsuario({
            ...selectUsuario,
            selected: null,
            active: false
        });
        setSelectServicio({
            ...selectServicio,
            selected: null,
            active: false
        });
        setSelectedServices([]);
        setSelectSucursal({
            ...selectSucursal,
            selected: null,
            visible: false,
        });
        setSelectProfesional({
            ...selectProfesional,
            selected: null,
            visible: false,
            cambiado: (fromGestion) ? true : false
        });
        setSelectDate({
            ...selectDate,
            visible: false
        });
        setSelectTime({
            ...selectTime,
            visible: false,
            touched: false
        });
        setSelectPromocion({
            promociones: [],
            visible: false,
            active: false
        });
        //setFechaCalendar(new Date());
        setFechaCalendar(moment(selectedDate).toDate());
        setTimeCalendar(new Date(1972, 10, 13, 0, 0));
        setPromocionesFiltradas(promociones);
        setTxtComentario('');
        setComentariosCita([]);
        setComentariosRespondidos(false);
        setProfesionalesPorServicio({});
        setMorningPorServicio({});
        setTimeCalendarPorServicio({});
        setSelectTimePorServicio({});
        setProfesionalPorServicioSlot({});
        setProfesionalesPorServicioLista({});
    };

    const handleUsuarioSelected = usuario => {
        if (!usuario || !usuario._id) {
            console.error('handleUsuarioSelected: usuario inválido', usuario);
            return;
        }
        dispatch(activeUsuario(usuario._id, usuario));

        setSelectUsuario({
            _id: usuario._id,
            selected: usuario,
            visible: true,
            active: false
        });
    };

    const handleServicioSelected = servicio => {
        dispatch(activeServicio(servicio._id, servicio));
        const service = servicios.filter(x=>x._id===servicio._id);
        setSelectedServices(service);
        setSelectServicio({
            _id: servicio._id,
            selected: servicio,
            visible: true,
            active: false
        });
        setSelectSucursal({
            ...selectSucursal,
            selected: null,
            visible: true,
        });
        setSelectProfesional({
            ...selectProfesional,
            selected: null,
            visible: false
        });
        setSelectDate({
            ...selectDate,
            visible: false
        });
        setSelectTime({
            ...selectTime,
            visible: false,
            touched: false
        });
        setSelectPromocion({
            promociones: [],
            visible: false,
            active: false
        });

        getSucursales(servicio, rdProfesionales, horarios, rdSucursales)
            .then(result => {
                setSucursales(result);
        });

		
    };
 

    const handleServicesChanged = (services) => {
        //handleComplementServices(services);
        setSelectedServices(services);
        setProfesionalesPorServicio({});
        if(rdSucursales.length>1 || services.length==0){
            setSelectSucursal({
                ...selectSucursal,
                selected: null,
                visible: true,
            });
            setSelectProfesional({
                ...selectProfesional,
                selected: null,
                visible: false
            });
        }
        setSelectDate({
            ...selectDate,
            visible: false
        });
        setSelectTime({
            ...selectTime,
            visible: false,
            touched: false
        });
        setSelectPromocion({
            promociones: [],
            visible: false,
            active: false
        });

        getSucursales(services, rdProfesionales, horarios, rdSucursales)
            .then(result => {
                setSucursales(result);
        });

		//TODO: (TONNY) Aqui deberíamos filtrar el array "servicios" para mostrar solamente los
		//servicios relacionados con los servicios seleccionados.
		//En el array de servicios deben quedar aquellos servicios que son complementarios de todos 
		//los servicios seleccionados.
    }

    const getServicio = (id) => {
        let retorno = null;
        const idStr = id != null ? String(id._id || id) : null;
        if (!idStr) return null;
        servicios.forEach(servicio => {
            if (servicio._id && String(servicio._id) === idStr) {
                retorno = servicio;
            }
        });
        return retorno;
    }

    const handleComplementServices = (selectedServices)=>{
        if(selectedServices.length>0){
            selectedServices[selectedServices.length - 1].complementarios.forEach(complementario => {
                const newService = getServicio(complementario);

                if (!newService) return;

                if (selectedServices.some(service => service._id === newService._id)) return;

                selectedServices = [
                    ...selectedServices,
                    newService
                ]
            });
        }
    }

    const handleVariantesChanged = (variantes) => {
        setSelectedVariantes(variantes);
        if(rdSucursales.length>1){
            setSelectSucursal({
                ...selectSucursal,
                selected: null,
                visible: true,
            });
            setSelectProfesional({
                ...selectProfesional,
                selected: null,
                visible: false
            });
            setSelectDate({
                ...selectDate,
                visible: false
            });
            setSelectTime({
                ...selectTime,
                visible: false,
                touched: false
            });
            setSelectPromocion({
                promociones: [],
                visible: false,
                active: false
            });
        }

    }

    const handleMetodoPagoSelected = (metodoPago) => {
        setSelectPromocion({
            ...selectPromocion,
            promociones: [],
            visible: true,
            active: false
        });
    };

    const handleSucursalSelected = sucursal => {
        setSelectSucursal({
            ...selectSucursal,
            visible: true,
            selected: sucursal,
            active: false,
        });
        
        if (selectedServices.length > 1) {
            setSelectDate({
                ...selectDate,
                visible: true
            });
            setSelectTime({
                ...selectTime,
                visible: false,
                touched: false
            });
        } else {
        setSelectProfesional({
            ...selectProfesional,
            selected: null,
            visible: true
        });
        setSelectDate({
            ...selectDate,
            visible: true
        });
        setSelectTime({
            ...selectTime,
            visible: true,
            touched: false
        });
        }
        
        setSelectPromocion({
            promociones: [],
            visible: false,
            active: false
        });
    };

    const handleProfesionalSelected = profesional => {
        setSelectProfesional({
            ...selectProfesional,
            visible: true,
            selected: profesional,
            active: false,
            cambiado: true
        });
        if (!esIdProfesionalAleatorio(profesional._id)) {
            setProfSelected('');
            horariosEranAleatorioRef.current = false;
        }
        setSelectDate({
            ...selectDate,
            visible: true
        });
        setSelectTime({
            ...selectTime,
            visible: true,
            touched: false
        });
        setSelectPromocion({
            promociones: [],
            visible: true,
            active: false
        });
        setTimeCalendar(new Date(1972, 10, 13, 0, 0));
        setIsLoadingAvailability(true);
    };

    const handlePromocionSelected = promocion => {

    };

    const closeModal = (e, deleteCita = false) => {
        const valorCambiado = (fromGestion) ? true : false;
        const newProfesional = {
            ...selectProfesional,
            cambiado: valorCambiado
        };
        if(fromGestion){
            setSelectProfesional(newProfesional);
            setFormErrores({});
            
            resetForm();
            setPromocionesFiltradas(promociones);
            if (!deleteCita && !fromCliente) {
                dispatch(unactiveCita());
                dispatch(usuarioLogout());
            }
            dispatch(unactiveServicio());
            dispatch(unactiveSucursal());
            dispatch(unactiveProfesional());
            setTxtComentario('');
            setComentariosCita([]);
            setAlertasActive(false);
            setEditActive(false);
            setEditNotesOnly(false);
            setProfesionalesPorServicio({});
        }
		setEditCita(false);
        setEditActive(false);
        setEditNotesOnly(false);
        setActiveModalReserva(false);
        setProfesionalesPorServicio({});
    };

    const handleEditNotesOnly = () => {
        const idxComentarios = (citaActive?.servicios?.length > 1 && citaActive?.servicioActual)
            ? (citaActive.idxServicio !== undefined && citaActive.idxServicio >= 0
                ? citaActive.idxServicio
                : citaActive.servicios?.findIndex(sd => {
                    const sdId = sd.servicio?._id || sd.servicio;
                    const actualId = citaActive.servicioActual.servicio?._id || citaActive.servicioActual.servicio;
                    return String(sdId) === String(actualId);
                }))
            : null;

        let comentariosFinales = comentariosCita.filter(comentario => comentario.business !== false);
        if (txtComentario.trim() !== '') {
            const comentarioInicial = {
                texto: txtComentario.trim(),
                leido: false,
                usuario: usuarioActivoResolved?._id || usuarioActivoResolved,
                business: false,
                fecha: new Date(),
                ...(idxComentarios != null && { idxServicio: idxComentarios })
            };
            comentariosFinales = [comentarioInicial, ...comentariosFinales.map(c => ({
                ...c,
                ...(idxComentarios != null && { idxServicio: idxComentarios })
            }))];
        } else {
            comentariosFinales = comentariosFinales.map(c => ({
                ...c,
                ...(idxComentarios != null && { idxServicio: idxComentarios })
            }));
        }

        if (idxComentarios != null && citaActive?.comentarios?.length > 0) {
            const otrosComentarios = citaActive.comentarios.filter(c =>
                c.idxServicio != null && c.idxServicio !== idxComentarios
            );
            comentariosFinales = [...otrosComentarios, ...comentariosFinales];
        }

        dispatch(startSaveComentariosCita(citaActive._id, comentariosFinales)).then(() => {
            setEditActive(false);
            setEditNotesOnly(false);
            setEditCita(false);
            setTxtComentario('');
            setComentariosCita([]);
            setActiveModalReserva(false);
        });
    }

    const handleEditCita = async () => {
        if (editCita && citaActive?.servicios && citaActive.servicios.length > 1 && citaActive?.servicioActual && selectedServices.length === 1) {
            const servicioActual = citaActive.servicioActual;
            const servicioIdActual = servicioActual.servicio?._id || servicioActual.servicio;
            const selectedServiceId = selectedServices[0]?._id || selectedServices[0];
            
            if (String(servicioIdActual) === String(selectedServiceId)) {
                const profesionalOriginal = servicioActual.profesional?._id || servicioActual.profesional;
                const profesionalNuevo = selectProfesional.selected?._id;
                
                const soloCambioProfesional = profesionalNuevo 
                    && profesionalNuevo !== '333'
                    && String(profesionalNuevo) !== String(profesionalOriginal);
                
                if (soloCambioProfesional) {
                    const idxServicio = citaActive.servicios.findIndex(sd => {
                        const sdId = sd.servicio?._id || sd.servicio;
                        return String(sdId) === String(servicioIdActual);
                    });
                    
                    if (idxServicio >= 0) {
                        const result = await handleCambiarProfesionalServicio(idxServicio, profesionalNuevo);
                        if (result && result.ok) {
                            closeModal(null);
                            return;
                        }
                    }
                }
            }
        }

        let esCambioSoloProfesional = false;
        if (editCita && citaActive?.servicios && citaActive.servicios.length > 1 && citaActive?.servicioActual && selectedServices.length === 1) {
            const servicioActual = citaActive.servicioActual;
            const servicioIdActual = servicioActual.servicio?._id || servicioActual.servicio;
            const selectedServiceId = selectedServices[0]?._id || selectedServices[0];
            
            if (String(servicioIdActual) === String(selectedServiceId)) {
                const profesionalOriginal = servicioActual.profesional?._id || servicioActual.profesional;
                const profesionalNuevo = selectProfesional.selected?._id;
                
                esCambioSoloProfesional = profesionalNuevo 
                    && profesionalNuevo !== '333'
                    && String(profesionalNuevo) !== String(profesionalOriginal);
            }
        }

        if (selectProfesional.selected._id === '333' && !profSelected?._id) {
            dispatch(openModalBottom({
                text: ['Debes seleccionar una hora válida para asignar un profesional aleatorio'],
                timeOut: 3
            }));
            return;
        }

        if (!esCambioSoloProfesional && timeCalendar.toISOString() === '1972-11-12T23:00:00.000Z') {
            dispatch(openModalBottom({
                text: ['Debes seleccionar una hora válida para la cita'],
                timeOut: 3
            }));
            return;
        }
        
        const fecha = moment(fechaCalendar).format('DD MM YYYY');
        const hora = moment(timeCalendar).format('HH:mm');

        const fechaDef = moment(`${fecha} ${hora}`, 'DD MM YYYY HH:mm').toISOString();

        let profesionalGeneral = null;
        let profesionalDataGeneral = null;
        
        if (selectedServices.length === 1) {
            profesionalGeneral = (!esIdProfesionalAleatorio(selectProfesional.selected?._id) ? selectProfesional.selected?._id : profSelected._id);
            profesionalDataGeneral = profesionales.find(p => p._id === profesionalGeneral) || selectProfesional.selected;
        } else {
            profesionalDataGeneral = null;
        }
        
        const newCualquiera = calcularSeleccionAleatoria({
            cantidadServicios: selectedServices.length,
            horariosSolicitadosConAleatorio: horariosEranAleatorioRef.current,
            profesionalSeleccionadoId: selectProfesional.selected?._id,
            esEdicionMismoProfesional: editCita && firstProfesional === selectProfesional.selected?._id,
            citaActivaEsAleatoria: citaActive?.isProfesionalRandom
        });

		const userId = citaActive?.usuario?._id ? citaActive?.usuario._id : citaActive?.usuario;        

        const totalVariantes = selectedVariantes.reduce((total, varianteSelected) => {
            const id = varianteSelected && (varianteSelected._id || varianteSelected);
            const variante = variantes.find(v => String(v._id) === String(id));
            return total + (variante ? parseInt(variante.tiempo, 10) : 0);
        }, 0);

        const usuarioData = usuarioActivoResolved;
        
        let serviciosCalculados;
        let serviciosParaCalcular = selectedServices;
        let idxComentariosEdit = null;
        let idxServicioEditando = -1;
        let editandoUnServicioEspecifico = false;
        let serviciosTemporales;
        let todosLosServiciosIds = selectedServices.map(s => {
            const id = s._id?.toString() || s.toString();
            return id;
        });
        
        if (editCita && citaActive?.servicios && Array.isArray(citaActive.servicios) && citaActive.servicios.length > 1) {
            todosLosServiciosIds = citaActive.servicios?.map(s => {
                const id = s._id?.toString() || s.toString();
                return id;
            }) || [];
            
            const serviciosIdsSeleccionados = selectedServices.map(s => {
                const id = s._id?.toString() || s.toString();
                return id;
            });
            
            const todosLosServicios = citaActive.servicios || [];
            serviciosParaCalcular = todosLosServiciosIds.length === serviciosIdsSeleccionados.length 
                ? selectedServices 
                : todosLosServicios.filter(s => {
                    const sId = s._id?.toString() || s.toString();
                    return todosLosServiciosIds.includes(sId);
                });
            
            idxServicioEditando = citaActive.idxServicio !== undefined && citaActive.idxServicio >= 0
                ? citaActive.idxServicio
                : (citaActive.servicioActual && citaActive.servicios
                    ? citaActive.servicios.findIndex(sd => {
                        const sdId = sd.servicio?._id || sd.servicio;
                        const actualId = citaActive.servicioActual.servicio?._id || citaActive.servicioActual.servicio;
                        return String(sdId) === String(actualId);
                    })
                    : -1);
            editandoUnServicioEspecifico = idxServicioEditando >= 0 && serviciosIdsSeleccionados.length === 1;
            serviciosTemporales = serviciosParaCalcular.length > 0 ? serviciosParaCalcular : selectedServices;
            if (editandoUnServicioEspecifico) idxComentariosEdit = idxServicioEditando;

            const fechaOriginalServicioEditado = editandoUnServicioEspecifico && citaActive.servicios[idxServicioEditando]
                ? moment(citaActive.servicios[idxServicioEditando].fechaInicio)
                : moment(citaActive.fecha);
            const fechaNueva = moment(fechaDef);
            const fechaCambio = !fechaOriginalServicioEditado.isSame(fechaNueva, 'minute');
            
            if (!fechaCambio && serviciosIdsSeleccionados.length === todosLosServiciosIds.length) {
                const serviciosActualizados = citaActive.servicios.map(servicioDetalle => {
                    const servicioId = servicioDetalle.servicio?._id?.toString() || servicioDetalle.servicio?.toString() || servicioDetalle.servicio;
                    const nuevoProfesionalId = profesionalesPorServicio[servicioId];
                    
                    if (nuevoProfesionalId && nuevoProfesionalId !== (servicioDetalle.profesional?._id?.toString() || servicioDetalle.profesional?.toString())) {
                        return {
                            ...servicioDetalle,
                            profesional: nuevoProfesionalId,
                            isProfesionalRandom: String(nuevoProfesionalId) === '333'
                        };
                    }
                    return servicioDetalle;
                });
                
                serviciosCalculados = serviciosActualizados;
            } else {
                serviciosTemporales = serviciosParaCalcular.length > 0 ? serviciosParaCalcular : selectedServices;
                const profesionalesPorServicioCompleto = {};
                
                citaActive.servicios.forEach((servicioDetalle) => {
                    const servicioId = servicioDetalle.servicio?._id?.toString() || servicioDetalle.servicio?.toString() || servicioDetalle.servicio;
                    const profesionalId = servicioDetalle.profesional?._id?.toString() || servicioDetalle.profesional?.toString();
                    if (servicioId && profesionalId) {
                        profesionalesPorServicioCompleto[servicioId] = profesionalesPorServicio[servicioId] || profesionalId;
                    }
                });
                
                const profesionalesPorServicioFinal = { ...profesionalesPorServicioCompleto, ...profesionalesPorServicio };
                
                try {
                    const serviciosTemp = [];
                    serviciosTemporales.forEach((servicio, index) => {
                        const servicioId = servicio._id?.toString() || servicio.toString();
                        const profesionalId = profesionalesPorServicioFinal[servicioId] || profesionalGeneral;
                        
                        let profesionalServicio = profesionales.find(p => p._id === profesionalId);
                        if (!profesionalServicio && serviciosTemporales.length === 1) {
                            profesionalServicio = profesionalDataGeneral;
                        }
                        
                        let duracionServicio = parseInt(servicio.duracion || 0);
                        
                        if (usuarioData && usuarioData.delay && usuarioData.delay !== "0") {
                            if (usuarioData.delayType === 'time') {
                                duracionServicio += parseInt(usuarioData.delay);
                            } else {
                                const porcentaje = parseInt(usuarioData.delay) / 100;
                                duracionServicio += Math.ceil(duracionServicio * porcentaje);
                            }
                        }
                        
                        if (profesionalServicio && profesionalServicio.delay && profesionalServicio.delay !== "0") {
                            if (profesionalServicio.delayType === 'time') {
                                duracionServicio += parseInt(profesionalServicio.delay);
                            } else {
                                const porcentaje = parseInt(profesionalServicio.delay) / 100;
                                duracionServicio += Math.ceil(duracionServicio * porcentaje);
                            }
                        }
                        
                        const editandoEsteServicio = editandoUnServicioEspecifico && index === idxServicioEditando;
                        const variantesParaEsteServicio = editandoEsteServicio
                            ? selectedVariantes  // Si estamos editando este servicio, usar las variantes actuales
                            : variantesCitaParaUI(citaActive, variantes, servicio._id || servicio);  // Si no, las guardadas de la cita para este servicio

                        if (variantesParaEsteServicio.length > 0) {
                            const tiempoVariantesEsteServicio = variantesParaEsteServicio
                                .reduce((total, varianteServicio) => total + parseInt(varianteServicio.tiempo || 0, 10), 0);
                            duracionServicio += tiempoVariantesEsteServicio;
                        }
                        
                        let fechaInicioEsteServicio;
                        if (editandoUnServicioEspecifico && idxServicioEditando >= 0) {
                            fechaInicioEsteServicio = null;
                        } else if (index === 0) {
                            fechaInicioEsteServicio = fechaCambio ? moment(fechaDef) : moment(citaActive.fecha);
                        } else {
                            const anterior = serviciosTemp[index - 1];
                            fechaInicioEsteServicio = moment(anterior.fechaInicio).add(anterior.duracion || 0, 'minutes');
                        }
                        
                        serviciosTemp.push({
                            servicio: servicio._id || servicio,
                            profesional: profesionalId,
                            fechaInicio: fechaInicioEsteServicio ? fechaInicioEsteServicio.toDate() : null,
                            duracion: duracionServicio,
                            isProfesionalRandom: String(profesionalId) === '333' || (citaActive.servicios?.[index]?.isProfesionalRandom === true && index === citaActive.servicios.findIndex(sd => sd.isProfesionalRandom === true)),
                            profesionalDelay: (citaActive.servicios?.[index]?.profesionalDelay != null && citaActive.servicios[index].profesionalDelay !== '') ? citaActive.servicios[index].profesionalDelay : (profesionalServicio?.delay ?? '0'),
                            profesionalDelayType: (citaActive.servicios?.[index]?.profesionalDelayType != null && citaActive.servicios[index].profesionalDelayType !== '') ? citaActive.servicios[index].profesionalDelayType : (profesionalServicio?.delayType ?? 'time')
                        });
                    });
                    
                    if (editandoUnServicioEspecifico && idxServicioEditando >= 0 && idxServicioEditando < serviciosTemp.length) {
                        serviciosTemp[idxServicioEditando].fechaInicio = moment(fechaDef).toDate();
                        for (let i = idxServicioEditando - 1; i >= 0; i--) {
                            const siguiente = serviciosTemp[i + 1];
                            serviciosTemp[i].fechaInicio = moment(siguiente.fechaInicio).subtract(serviciosTemp[i].duracion || 0, 'minutes').toDate();
                        }
                        for (let i = idxServicioEditando + 1; i < serviciosTemp.length; i++) {
                            const anterior = serviciosTemp[i - 1];
                            serviciosTemp[i].fechaInicio = moment(anterior.fechaInicio).add(anterior.duracion || 0, 'minutes').toDate();
                        }
                    }
                    
                    serviciosCalculados = serviciosTemp;
                } catch (error) {
                    dispatch(openModalBottom({
                        text: [error.message],
                        timeOut: 3
                    }));
                    return;
                }
            }
        } else {
            try {
                serviciosCalculados = calcularServiciosDetalle(
                    fechaDef,
                    profesionalGeneral,
                    usuarioData,
                    profesionalDataGeneral,
                    profSelected
                );
            } catch (error) {
                dispatch(openModalBottom({
                    text: [error.message],
                    timeOut: 3
                }));
                return;
            }
        }

        const profesionalReserva = selectedServices.length > 1 && serviciosCalculados.length > 0
            ? serviciosCalculados[0].profesional
            : profesionalGeneral;

        const serviciosFinalesIds = editCita && citaActive?.servicios && citaActive.servicios.length > 0
            ? citaActive.servicios.map(s => s._id || s)
            : selectedServices.map(servicio => servicio._id);

        const complementariosIds = [];
        if (selectedServices.length > 1) {
            for (let i = 1; i < selectedServices.length; i++) {
                const servicio = selectedServices[i];
                const servicioId = servicio._id || servicio;
                for (let j = 0; j < i; j++) {
                    const prev = selectedServices[j];
                    const prevComplementarios = prev.complementarios || [];
                    if (prevComplementarios.some(c => String(c._id || c) === String(servicioId))) {
                        complementariosIds.push(servicioId);
                        break;
                    }
                }
            }
        }
        const tieneComplementarios = complementariosIds.length > 0;
        const editConComplementariosPrevios = editCita && citaActive?.complementarios?.length > 0;
        const debeIncluirComplementarios = tieneComplementarios || (editConComplementariosPrevios && !tieneComplementarios);

        const sumaDuracion = serviciosParaCalcular.reduce((total, service) => {
            return total + parseInt(service.duracion || 0, 10);
        }, 0);
        
        const fechaPrincipalReserva = serviciosCalculados.length > 0
            ? serviciosCalculados[0].fechaInicio
            : fechaDef;

        const reserva = {
            empresa,
            ...citaActive,
			usuario: userId,			
            sucursal: selectSucursal.selected._id,
            profesional: profesionalReserva,
            ...(debeIncluirComplementarios
                ? { complementarios: tieneComplementarios ? complementariosIds : [] }
                : { complementarios: undefined }),
            fecha: fechaPrincipalReserva,
            isProfesionalRandom: newCualquiera,
            internal: true,
            duracion: serviciosCalculados.reduce((total, sd) => total + (sd.duracion || 0), 0),
            metodoPago: selectPromocion.promociones.length > 0 ? selectPromocion.promociones[0]._id : null,
            servicios: serviciosCalculados
        };

		const totalServiciosCentimos = selectedServices.reduce((total, service) => {
			return total + parseInt(service.precio, 10);
			}, 0);
		let precioReserva = totalServiciosCentimos;

		let promocionesConImporte = [];
		promocionesFiltradas.forEach(item => {
			if (item.selected && item.sucursales.includes(reserva.sucursal)) {
				// El descuento en céntimos se resta a precioReserva (que está en céntimos);
				// importeAplicado se persiste en euros, según la convención del backend.
				precioReserva -= parseFloat(calculaImporteDescuentos(item, selectedServices));
				promocionesConImporte.push({
					promocion: item._id,
					titulo: item.titulo,
					tipo: item.tipo,
					porcentaje: item.porcentaje,
					cifra: item.cifra,
					importeAplicado: calcularImporteAplicadoEuros(item, totalServiciosCentimos),
				});
			}
		});

		selectedVariantes.forEach(v => {
			if (v && (typeof v.valor === 'number' || !isNaN(parseFloat(v.valor)))) precioReserva += parseFloat(v.valor) || 0;
		});

        if (editCita && citaActive?.servicios?.length > 1 && editandoUnServicioEspecifico) {
            const servicioIdEditando = serviciosTemporales[idxServicioEditando]?._id?.toString() || serviciosTemporales[idxServicioEditando]?.toString();
            
            const variantesDeOtrosServicios = variantesCitaParaUI(citaActive, variantes)
                .filter(varianteGuardada => {
                    const serviciosVariante = Array.isArray(varianteGuardada.servicios) ? varianteGuardada.servicios : [];
                    if (serviciosVariante.length === 0) return false;
                    const perteneceAlServicioEditado = serviciosVariante.some(
                        servicioRef => String(servicioRef?._id || servicioRef) === String(servicioIdEditando)
                    );
                    return !perteneceAlServicioEditado;
                })
                .map(varianteGuardada => varianteGuardada._id);
            
            const variantesDelServicioEditado = selectedVariantes.map(v => (v && (v._id || v)) || v);
            
            reserva.variantes = [...new Set([...variantesDeOtrosServicios, ...variantesDelServicioEditado])];
        } else {
            reserva.variantes = selectedVariantes.map(v => (v && (v._id || v)) || v);
        }

        reserva.promociones = promocionesConImporte;

        let comentariosFinales = comentariosCita.filter(comentario => comentario.business !== false);
        if (txtComentario.trim() !== '') {
            const comentarioInicial = {
                texto: txtComentario.trim(),
                leido: false,
                usuario: usuarioActivoResolved._id,
                business: false,
                fecha: new Date(),
                ...(idxComentariosEdit != null && { idxServicio: idxComentariosEdit })
            };
            comentariosFinales = [comentarioInicial, ...comentariosFinales.map(c => ({
                ...c,
                ...(idxComentariosEdit != null && { idxServicio: idxComentariosEdit })
            }))];
        } else if (idxComentariosEdit != null) {
            comentariosFinales = comentariosFinales.map(c => ({ ...c, idxServicio: idxComentariosEdit }));
        }
        if (idxComentariosEdit != null && citaActive?.comentarios?.length > 0) {
            const otrosComentarios = citaActive.comentarios.filter(c =>
                c.idxServicio != null && c.idxServicio !== idxComentariosEdit
            );
            comentariosFinales = [...otrosComentarios, ...comentariosFinales];
        }
        reserva.comentarios = comentariosFinales;
        reserva.importe = precioReserva / 100;
		reserva.uid = uid;

        if (usarSockets) {
            socket?.emit('grabar-cita', { uid, reserva, internal: true });
        } else {
            setModalWaiting(reserva);
            setModalTwoButtonsOpened(true);
        }
    }

    const clickReservar = (editar) => {
        if (isCreatingCita) return;
        //if (!registerFormOk) return;
        const fecha = moment(fechaCalendar).format('DD MM YYYY');
        const hora = moment(timeCalendar).format('HH:mm');

        const fechaDef = moment(`${fecha} ${hora}`, 'DD MM YYYY HH:mm').toISOString();

        let reservaOk = true;
        let errores = {
            cliente: false,
            servicio: false,
            sucursal: false,
            profesional: false,
            hora: false
        };

        if (!usuarioActivoResolved && fromGestion) {
            errores.cliente = true;
            reservaOk = false;
        }
        //if (!selectServicio.selected) {
        if (!selectedServices.length) {
            errores.servicio = true;
            reservaOk = false;
        }
        if (!selectSucursal.selected) {
            errores.sucursal = true;
            reservaOk = false;
        }
        if (selectedServices.length > 1) {
            const serviciosSinProfesional = selectedServices.filter(servicio => !profesionalesPorServicio[servicio._id]);
            if (serviciosSinProfesional.length > 0) {
                errores.profesional = true;
                reservaOk = false;
            }
        } else {
        if (!selectProfesional.selected) {
            errores.profesional = true;
            reservaOk = false;
            }
        }
        if (timeCalendar.toISOString() === '1972-11-12T23:00:00.000Z') {
            errores.hora = true;
            reservaOk = false;
        } else {
            const allSlots = [...morning, ...afternoon];
            const horaEnRango = allSlots.some(s =>
                moment(s.date).format('YYYY-MM-DD HH:mm') === moment(timeCalendar).format('YYYY-MM-DD HH:mm')
            );
            if (!horaEnRango) {
                errores.hora = true;
                reservaOk = false;
                dispatch(openModalBottom({ text: ['La hora seleccionada ya no está disponible. Elige otra hora.'], timeOut: 4 }));
            }
        }
        const hayVariosProfesionales = selectedServices.length > 1 && [...new Set(selectedServices.map((s, i) => {
            const id = profesionalesPorServicio[s._id];
            return (id === '333' || id === 333) ? `random_${i}` : id;
        }).filter(Boolean))].length >= 2;
        if (hayVariosProfesionales) {
            const faltanHoras = selectedServices.slice(1).filter(s => !timeCalendarPorServicio[s._id]);
            if (faltanHoras.length > 0) {
                const nombres = faltanHoras.map(s => s.nombre).join(', ');
                dispatch(openModalBottom({ text: [`Selecciona una hora disponible para: ${nombres}`], timeOut: 4 }));
                reservaOk = false;
            }
        }

        // Calcular el precio total de la reserva
        const totalServiciosCentimos = selectedServices.reduce((total, service) => {
            return total + parseInt(service.precio, 10);
         }, 0);
        let precioReserva = totalServiciosCentimos;
        let promocionesConImporte = [];
        promocionesFiltradas.forEach(item => {
            if (item.selected && item.sucursales.includes(selectSucursal.selected?._id)) {
                // El descuento en céntimos se resta a precioReserva (que está en céntimos);
                // importeAplicado se persiste en euros, según la convención del backend.
                precioReserva -= parseFloat(calculaImporteDescuentos(item, selectedServices));
                promocionesConImporte.push({
                    promocion: item._id,
                    titulo: item.titulo,
                    tipo: item.tipo,
                    porcentaje: item.porcentaje,
                    cifra: item.cifra,
                    importeAplicado: calcularImporteAplicadoEuros(item, totalServiciosCentimos),
                });
            }
        });
        selectedVariantes.forEach(v => {
            if (v && (typeof v.valor === 'number' || !isNaN(parseFloat(v.valor)))) precioReserva += parseFloat(v.valor) || 0;
        });

        if (reservaOk) {
            let profesionalGeneral = null;
            let profesionalDataGeneral = null;
            
            if (selectedServices.length === 1) {
                profesionalGeneral = (!esIdProfesionalAleatorio(selectProfesional.selected?._id) ? selectProfesional.selected?._id : profSelected._id);
                profesionalDataGeneral = profesionales.find(p => p._id === profesionalGeneral) || selectProfesional.selected;
            } else {
                profesionalDataGeneral = null;
            }
            
            const newCualquiera = calcularSeleccionAleatoria({
                cantidadServicios: selectedServices.length,
                horariosSolicitadosConAleatorio: horariosEranAleatorioRef.current,
                profesionalSeleccionadoId: selectProfesional.selected?._id,
                esEdicionMismoProfesional: editCita && firstProfesional === selectProfesional.selected?._id,
                citaActivaEsAleatoria: citaActive?.isProfesionalRandom
            });

            const sumaDuracion = selectedServices.reduce((total, service) => {
                return total + parseInt(service.duracion, 10);
            }, 0);
            
            const usuarioData = usuarioActivoResolved;
            
            let serviciosCalculados;
            try {
                if (hayVariosProfesionales && selectedServices.slice(1).every(s => timeCalendarPorServicio[s._id])) {
                    const primeraFecha = moment(fechaDef);
                    let fechaInicioAcumulada = primeraFecha.clone();
                    const slotsDisponiblesPorServicio = (idx, sid) => (idx === 0 ? (morningPorServicio[sid] || morning) : (morningPorServicio[sid] || []));
                    const horaCoincideConSlot = (horaMoment, slots) => slots.length > 0 && slots.some(s => {
                        const slotHora = moment(s.date);
                        return slotHora.format('HH:mm') === horaMoment.format('HH:mm') && slotHora.isSame(horaMoment, 'day');
                    });
                    serviciosCalculados = selectedServices.map((servicio, index) => {
                        const servicioId = servicio._id?.toString() || servicio._id;
                        let profesionalId = profesionalesPorServicio[servicioId];
                        const esAleatorio = esProfesionalAleatorioEnSlot(profesionalId);
                        if (esAleatorio) {
                            let pSlot = index === 0 ? profSelected : profesionalPorServicioSlot[servicioId];
                            if (index > 0 && !pSlot && morningPorServicio[servicioId]?.length > 0 && timeCalendarPorServicio[servicioId]) {
                                const horaSeleccionada = moment(timeCalendarPorServicio[servicioId]);
                                const slotCoincide = morningPorServicio[servicioId].find(s => {
                                    const slotHora = moment(s.date);
                                    return slotHora.format('HH:mm') === horaSeleccionada.format('HH:mm') && slotHora.isSame(horaSeleccionada, 'day');
                                });
                                if (slotCoincide?.profesional) pSlot = slotCoincide.profesional;
                            }
                            if (!pSlot && index > 0) pSlot = profSelected;
                            const p = pSlot && typeof pSlot === 'object' && pSlot._id ? pSlot._id : pSlot;
                            if (p) profesionalId = p;
                        }
                        let duracionServicio = (servicio.duracion1 > 0 && (servicio.pausa || 0) >= 0 && servicio.duracion2 > 0)
                            ? parseInt(servicio.duracion1 || 0) + parseInt(servicio.pausa || 0) + parseInt(servicio.duracion2 || 0)
                            : parseInt(servicio.duracion || 0);
                        if (usuarioData?.delay && usuarioData.delay !== '0') {
                            if (usuarioData.delayType === 'time') duracionServicio += parseInt(usuarioData.delay);
                            else duracionServicio += Math.ceil(duracionServicio * (parseInt(usuarioData.delay) / 100));
                        }
                        const profServicio = profesionales.find(p => p._id === profesionalId);
                        if (profServicio?.delay && profServicio.delay !== '0') {
                            if (profServicio.delayType === 'time') duracionServicio += parseInt(profServicio.delay);
                            else duracionServicio += Math.ceil(duracionServicio * (parseInt(profServicio.delay) / 100));
                        }
                        if (selectedVariantes.length > 0) {
                            const tiempoVar = selectedVariantes
                                .filter(v => Array.isArray(v?.servicios) && v.servicios.some(sId => String(sId?._id || sId) === String(servicio._id)))
                                .reduce((t, v) => t + parseInt(v.tiempo || 0, 10), 0);
                            duracionServicio += tiempoVar;
                        }
                        const horaSeleccionadaEsteServicio = index === 0 ? primeraFecha : (timeCalendarPorServicio[servicioId] ? moment(timeCalendarPorServicio[servicioId]) : null);
                        let fechaInicioMoment = horaSeleccionadaEsteServicio || fechaInicioAcumulada;
                        if (index > 0 && fechaInicioMoment.isBefore(fechaInicioAcumulada, 'minute')) {
                            fechaInicioMoment = fechaInicioAcumulada.clone();
                        }
                        const fechaInicio = fechaInicioMoment.toDate();
                        fechaInicioAcumulada = moment(fechaInicio).add(duracionServicio, 'minutes');
                        return {
                            servicio: servicio._id,
                            profesional: profesionalId,
                            fechaInicio,
                            duracion: duracionServicio,
                            isProfesionalRandom: !!esAleatorio,
                            profesionalDelay: profServicio?.delay ?? '0',
                            profesionalDelayType: profServicio?.delayType ?? 'time'
                        };
                    }).filter(Boolean);
                    const validarHorasDisponibles = () => {
                        for (let i = 0; i < serviciosCalculados.length; i++) {
                            const det = serviciosCalculados[i];
                            const sid = det.servicio?.toString?.() || det.servicio;
                            const slots = slotsDisponiblesPorServicio(i, sid);
                            if (slots.length > 0) {
                                const horaInicio = moment(det.fechaInicio);
                                if (!horaCoincideConSlot(horaInicio, slots)) {
                                    return { ok: false, msg: `La hora del bloque ${i + 1} no coincide con un hueco disponible. Selecciona una hora de la lista.` };
                                }
                            }
                        }
                        return { ok: true };
                    };
                    let validacion = validarHorasDisponibles();
                    if (!validacion.ok) {
                        dispatch(openModalBottom({ text: [validacion.msg], timeOut: 4 }));
                        return;
                    }
                } else {
                    serviciosCalculados = calcularServiciosDetalle(
                        fechaDef,
                        profesionalGeneral,
                        usuarioData,
                        profesionalDataGeneral,
                        profSelected
                    );
                }
            } catch (error) {
                dispatch(openModalBottom({
                    text: [error.message],
                    timeOut: 3
                }));
                return;
            }
            
            const profesionalReserva = selectedServices.length > 1 && serviciosCalculados.length > 0
                ? serviciosCalculados[0].profesional
                : profesionalGeneral;
            
            const duracionTotalReserva = serviciosCalculados && serviciosCalculados.length > 0
                ? serviciosCalculados.reduce((acc, s) => acc + (s.duracion || 0), 0)
                : parseInt(sumaDuracion) + selectedServices.reduce((acc, s) => acc + (selectedVariantes
                    .filter(v => v && Array.isArray(v.servicios) && v.servicios.some(sId => String(sId?._id || sId) === String(s._id)))
                    .reduce((t, v) => t + parseInt(v.tiempo || 0, 10), 0)), 0);
            const reserva = {
                empresa,
                sucursal: selectSucursal.selected._id,
                profesional: profesionalReserva,
                usuario: usuarioActivoResolved._id,
                fecha: fechaDef,
                isProfesionalRandom: newCualquiera,
                internal: true,                
                duracion: duracionTotalReserva,
                servicios: serviciosCalculados
            };
            if (telefonoReserva?.trim()) {
                reserva.telefono = telefonoReserva.trim();
            }

            reserva.variantes = selectedVariantes.map(v => (v && (v._id || v)) || v);
            reserva.promociones = promocionesConImporte;

            let comentariosFinales = [...comentariosCita];
            
            comentariosFinales = comentariosFinales.filter(comentario => comentario.business !== false);
            
            if (txtComentario.trim() !== '') {
                const comentarioInicial = {
                    texto: txtComentario.trim(),
                    leido: false,
                    usuario: usuarioActivoResolved._id,
                    business: false,
                    fecha: new Date()
                };
                comentariosFinales = [comentarioInicial, ...comentariosFinales];
            }
            reserva.comentarios = comentariosFinales;
            reserva.importe = precioReserva / 100;

            if (reserva.profesional !== '333') {
                if (usarSockets) {
                    socket?.emit('crear-cita', { uid, reserva, internal: true });
                    closeModal(null);
                } else {
                    setIsCreatingCita(true);
                    dispatch(startNewCita(reserva)).then(async (response) => {
                        setIsCreatingCita(false);
                        setModalResponse(100);
                        if (fromCliente && usuarioActive?._id) {
                            dispatch(getCitas(usuarioActive._id, reserva.empresa));
                        }
                        setEditCita(false);
                        setActiveModalReserva(false);
                        closeModal(null);
                    }).catch(() => {
                        setIsCreatingCita(false);
                    });
                }
            }
        } else {
            setFormErrores(errores);
        }
    }

    const clickEliminar = (cita) => {
        dispatch(activeCita(cita._id, cita));
        setEstadoCita('');
        setActiveModalDeleteCita(true);
        closeModal(null, true);
    }

    const clickNoPresentado = () => {
        dispatch(activeCita(citaActive._id, citaActive));
        setEstadoCita('No presentado');
        setActiveModalDeleteCita(true);
        closeModal(null, true);
    }

    const handleEnviarTicket = async () => {
        const clienteNombre = citaActive?.usuario?.nombre || 'el cliente';
        const { isConfirmed } = await Swal.fire({
            title: 'Enviar ticket',
            text: `¿Enviar ticket de venta a ${clienteNombre}?`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Enviar',
            cancelButtonText: 'Cancelar',
        });
        if (!isConfirmed) return;

        setEnviandoTicket(true);
        const resp = await dispatch(startEnviarTicketVenta(citaActive._id));
        setEnviandoTicket(false);
        if (resp && resp.ok) {
            dispatch(refreshCita(citaActive._id, { ...citaActive, ticketEnviado: true }));
            dispatch(openModalBottom({ text: ['Ticket enviado correctamente'], timeOut: 3 }));
        } else {
            dispatch(openModalBottom({ text: [resp?.msg || 'Error al enviar el ticket'], timeOut: 3 }));
        }
    }

    const calculaImporteDescuento = (promocion, servicio) => {
        let retorno = '0';
        if (promocion.cifra) {
            retorno = promocion.cifra;
        } else {
            const precioServicio = parseFloat(servicio.precio);
            if (!isNaN(precioServicio) && promocion.porcentaje) {
                retorno = (precioServicio * (Number(promocion.porcentaje) / 100)).toString();
            }
        }
        return retorno;
    };

    const calculaImporteDescuentos = (promocion, servicios) => {
        let acumRetorno = 0;
        if (promocion.cifra) {
            acumRetorno = parseFloat(promocion.cifra);
        } else {
            for (let i = 0; i < servicios.length; i++) {
                const precioServicio = parseFloat(servicios[i].precio);
                if (!isNaN(precioServicio) && promocion.porcentaje) {
                    acumRetorno += precioServicio * (Number(promocion.porcentaje) / 100);
                }
            }
        }
        return acumRetorno.toString();
    };

    const sendRespuesta = () => {
        if (txtComentario.trim() === '') {
            alert('Debe escribir en el campo comentario');
            return;
        }
        const newComentario = {
            texto: txtComentario,
            leido: false,
            usuario: citaActive.usuario?._id || null,
            business: true
        }
        setComentariosCita([
            ...comentariosCita,
            newComentario
        ]);
        setGrabaComentarios(true);
    };

    const recalculaPromociones = () => {
        if (servicioActive && selectTime.touched) {
            let promocionesValidas = promociones.filter(promo => {
                const fechaInicio = moment(promo.fechaInicio);
                const caducidad = moment(promo.caducidad);
                let fechaCita = moment(fechaCalendar);
                if (citaActive) {
                    fechaCita = moment(citaActive.fecha);
                }

                const valida = !promo.deleted && promo.activo && fechaInicio.isSameOrBefore(fechaCita) && caducidad.isSameOrAfter(fechaCita) && promo.servicios.includes(selectServicio.selected?._id) && promo.sucursales.includes(selectSucursal.selected?._id) && (promo.profesionales.includes(selectProfesional.selected?._id) || (promo.profAleatorio && selectProfesional.selected?._id === '333')) && compruebaHorariosPromocion(promo);

                return valida;
            });

            if (citaActive) {
                let nuevosIds = [];
                (citaActive.promociones || []).forEach(promo => {
                    const promoId = promo.promocion || promo._id;
                    let existe = false;
                    promocionesValidas.forEach(pv => {
                        if (pv._id === promoId) {
                            existe = true;
                        }
                    });
                    if (!existe) {
                        if (!nuevosIds.includes(promoId)) {
                            nuevosIds = [...nuevosIds, promoId];
                        }
                    }
                });
                if (nuevosIds.length > 0) {
                    nuevosIds.forEach(id => {
                        const nuevaPromo = promociones.filter(promo => promo._id === id);
                        if (nuevaPromo.length > 0) {
                            promocionesValidas = [...promocionesValidas, nuevaPromo[0]];
                        }
                    });
                }
            }

            let newPromociones = [];
            if (citaActive?.promociones?.some(p => p.importeAplicado > 0) && fromGestion) {
                promocionesValidas.forEach(item => {
                    let promSelected = false;
                    (citaActive.promociones || []).forEach(promo => {
                        const promoId = promo.promocion || promo._id;
                        if (promoId === item._id) {
                            promSelected = true;
                        }
                    });
                    item.selected = promSelected;
                    newPromociones = [
                        ...newPromociones,
                        item
                    ]
                });
            } else {
                newPromociones = promocionesValidas;
            }
            setPromocionesFiltradas(newPromociones);
        }
    }

    const compruebaHorariosPromocion = (promo) => {
        let estaEnHorario = true;
        let fechaCita = moment(timeCalendar);
        const weekDay = fechaCita.weekday().toString();
        fechaCita = fechaCita.set({ 'year': 2021, 'month': 2, 'date': 19 });

        if (promo.horarioEspecial) {
            estaEnHorario = false;
            const horarios = promo.horariosPromocion;
            horarios.forEach(dia => {
                const mismoDia = dia.diasSemana === weekDay;
                if (mismoDia && dia.horas.length > 0) {
                    estaEnHorario = dia.horas.filter(hora => {
                        const horaInicio = moment(hora.horaInicio).set({ 'year': 2021, 'month': 2, 'date': 19 });
                        const horaFin = moment(hora.horaFin).set({ 'year': 2021, 'month': 2, 'date': 19 });
                        const respuesta = fechaCita.isSameOrAfter(horaInicio) && fechaCita.isBefore(horaFin);
                        return respuesta;
                    }).length > 0 ? true : false;
                };
            });
        }

        return estaEnHorario;
    }

	const historyPath = ()=> { 		
		if(!usuarioActivoResolved) return
		
		const fechaParaRegresar = (editCita && citaActive) ? citaActive.fecha : selectedDate;
		
		let fechaFinal = null;
		if (fechaParaRegresar) {
			if (moment.isMoment(fechaParaRegresar)) {
				fechaFinal = fechaParaRegresar.toISOString();
			} else {
				fechaFinal = moment(fechaParaRegresar).toISOString();
			}
		}
		
		const calendarState = {
			selectedDate: fechaFinal,
			viewValue: viewValue,
			citaId: citaActive?._id,
			previousSelectedDate: viewValue === 'today' ? previousSelectedDate?.toISOString() : null
		};
		
		return {
			pathname: `/cliente/${usuarioActivoResolved._id}`, 
			state: { 
				usuario: usuarioActivoResolved,
				calendarState: calendarState
			}
		}
	}

	const handleEditarCita = () => {
		const now = moment();
		const citaTime = moment(citaActive.fecha);
		const horasCancelacion = empresas.find(e => e._id === empresa)?.horasCancelacion ?? 0;
		const minutosCancelacion = horasCancelacion * 60;
		const canEdit = citaTime.diff(now, 'minutes') > minutosCancelacion;

		setEditActive(true);
		if (canEdit) {
			setEditNotesOnly(false);
		} else {
			setEditNotesOnly(true);
		}
	}

    const handleCambiarProfesionalServicio = async (servicioIndex, nuevoProfesionalId) => {
		if (!citaActive || !citaActive._id) return { ok: false };
		
		let idxServicio = servicioIndex;
		
		if (citaActive.servicioActual && servicioIndex !== null) {
			const servicioIdActual = citaActive.servicioActual.servicio?._id || citaActive.servicioActual.servicio;
			if (citaActive.servicios) {
				const idxEncontrado = citaActive.servicios.findIndex(sd => {
					const sdId = sd.servicio?._id || sd.servicio;
					return String(sdId) === String(servicioIdActual);
				});
				if (idxEncontrado >= 0) {
					idxServicio = idxEncontrado;
				}
			}
		}
		
		try {
			const result = await dispatch(startCambiarProfesionalServicio(
				citaActive._id,
				idxServicio,
				nuevoProfesionalId
			));
			
			if (result && result.ok) {
				const updatedCita = {
					...result.cita,
					servicioActual: result.cita.servicios?.[idxServicio] || citaActive.servicioActual,
					idxServicio: citaActive.idxServicio
				};
				dispatch(activeCita(citaActive._id, updatedCita));
				return { ok: true };
			}
			return { ok: false };
		} catch (error) {
			console.error('Error al cambiar profesional:', error);
			return { ok: false };
		}
	};


    const ProfesionalPorServicioDropdown = ({ servicio, profesionalSeleccionado, profesionalesDisponibles, isDropdownOpen, dropdownRef, onToggle, onSelect, colores, setProfesionalesDropdowns }) => {
        const servicioId = servicio._id;
        
        useEffect(() => {
            const handleClickOutside = (event) => {
                if (dropdownRef?.current && !dropdownRef.current.contains(event.target)) {
                    setProfesionalesDropdowns(prev => ({ ...prev, [servicioId]: false }));
                }
            };
            
            if (isDropdownOpen) {
                document.addEventListener('mousedown', handleClickOutside);
                return () => {
                    document.removeEventListener('mousedown', handleClickOutside);
                };
            }
        }, [isDropdownOpen, servicioId, dropdownRef, setProfesionalesDropdowns]);
        
        return (
            <div className="brb-select" style={{ marginBottom: '10px' }}>
                <div 
                    className={`brb-select-container visible ${isDropdownOpen ? 'active' : ''}`}
                    onClick={onToggle}
                >
                    <p style={{ margin: 0, color: 'white' }}>
                        {profesionalSeleccionado ? profesionalSeleccionado.nombre : `${servicio.nombre}: Selecciona profesional`}
                    </p>
                    <div className="right-zone">
                        <p></p>
                        <span className="select-arrow select-arrow-down"></span>
                    </div>
                </div>
                <div 
                    ref={dropdownRef}
                    className={`brb-select-options select-profesional ${isDropdownOpen ? 'active' : ''}`}
                >
                    {profesionalesDisponibles.map((prof) => (
                        <div
                            key={prof._id}
                            className="brb-select-option"
                            style={{ backgroundColor: colores.color6 }}
                            onClick={() => onSelect(prof._id)}
                        >
                            <p>{prof.nombre}</p>
                        </div>
                    ))}
                </div>
            </div>
        );
    };

    const calcularServiciosDetalle = (fechaInicio, profesionalGeneral, usuarioData, profesionalDataGeneral, profSelectedSlot = null) => {
        const servicios = [];
        let fechaInicioServicio = moment(fechaInicio);
        
        selectedServices.forEach((servicio, index) => {
            let profesionalId;
            let esAleatorio = false;
            if (selectedServices.length > 1) {
                profesionalId = profesionalesPorServicio[servicio._id];
                esAleatorio = profesionalId === '333' || profesionalId === 'random' || String(profesionalId) === '333';
                if (esAleatorio) {
                    if (!profSelectedSlot) {
                        throw new Error('Selecciona una hora en el calendario para asignar un profesional');
                    }
                    profesionalId = profSelectedSlot._id ?? profSelectedSlot;
                }
                if (!profesionalId) {
                    throw new Error(`El servicio "${servicio.nombre}" no tiene profesional asignado`);
                }
            } else {
                profesionalId = profesionalesPorServicio[servicio._id] || profesionalGeneral;
                esAleatorio = profesionalId === '333' || String(profesionalId) === '333';
            }
            
            let profesionalServicio = profesionales.find(p => p._id === profesionalId);
            if (!profesionalServicio) {
                if (selectedServices.length === 1) {
                    profesionalServicio = profesionalDataGeneral;
                } else {
                    throw new Error(`No se encontró el profesional asignado al servicio "${servicio.nombre}"`);
                }
            }
            
            let duracionServicio = (servicio.duracion1 > 0 && (servicio.pausa || 0) >= 0 && servicio.duracion2 > 0)
                ? parseInt(servicio.duracion1 || 0) + parseInt(servicio.pausa || 0) + parseInt(servicio.duracion2 || 0)
                : parseInt(servicio.duracion || 0);
            
            if (usuarioData && usuarioData.delay && usuarioData.delay !== "0") {
                if (usuarioData.delayType === 'time') {
                    duracionServicio += parseInt(usuarioData.delay);
                } else {
                    const porcentaje = parseInt(usuarioData.delay) / 100;
                    duracionServicio += Math.ceil(duracionServicio * porcentaje);
                }
            }
            
            if (profesionalServicio && profesionalServicio.delay && profesionalServicio.delay !== "0") {
                if (profesionalServicio.delayType === 'time') {
                    duracionServicio += parseInt(profesionalServicio.delay);
                } else {
                    const porcentaje = parseInt(profesionalServicio.delay) / 100;
                    duracionServicio += Math.ceil(duracionServicio * porcentaje);
                }
            }
            
            if (selectedVariantes.length > 0) {
                const tiempoVariantesEsteServicio = selectedVariantes
                    .filter(v => v && Array.isArray(v.servicios) && v.servicios.some(sId => String(sId?._id || sId) === String(servicio._id)))
                    .reduce((total, v) => total + parseInt(v.tiempo || 0, 10), 0);
                duracionServicio += tiempoVariantesEsteServicio;
            }
            
            servicios.push({
                servicio: servicio._id,
                profesional: profesionalId,
                fechaInicio: fechaInicioServicio.toDate(),
                duracion: duracionServicio,
                isProfesionalRandom: esAleatorio
            });
            
            fechaInicioServicio = fechaInicioServicio.add(duracionServicio, 'minutes');
        });
        
        return servicios;
    };

    const editandoServicioContexto = editCita && citaActive?.servicios?.length > 1 && citaActive?.servicioActual && (() => {
        const idx = citaActive.idxServicio !== undefined && citaActive.idxServicio >= 0
            ? citaActive.idxServicio
            : citaActive.servicios?.findIndex(sd => {
                const sdId = sd.servicio?._id || sd.servicio;
                const actualId = citaActive.servicioActual.servicio?._id || citaActive.servicioActual.servicio;
                return String(sdId) === String(actualId);
            });
        if (idx < 0) return null;
        const actualId = citaActive.servicioActual.servicio?._id || citaActive.servicioActual.servicio;
        const servicio = resolverServicioEnCita(citaActive, actualId, servicios)
            || citaActive.servicios?.find(referenciaServicio => {
            const servicioIdReferencia = referenciaServicio._id || referenciaServicio;
            return String(servicioIdReferencia) === String(actualId);
        });
        return {
            indice: idx + 1,
            total: citaActive.servicios.length,
            nombre: servicio?.nombre || 'Servicio'
        };
    })();

    return (
        <>
            <div
                className={`modal-reserva ${(activeModalReserva) ? 'active' : ''} ${(!editActive && editCita && citaActive) ? 'modal-reserva--info' : ''}`}
                style={{
                    '--colorPrincipal': colores.colorPrincipal,
                    '--colorSecundario': colores.colorSecundario,
                    '--color3': colores.color3,
                    '--color4': colores.color4,
                    '--color5': colores.color5,
                    '--color6': colores.color6,
                    '--color7': colores.color7,
                }}
            >
                <div className="modal-wrapper">
                    <div className="modal-title">
                        <div
                            className='btn-title'
                            onClick={() => setAlertasActive(false)}
                        >
                            <h3 style={{ color: colores.colorPrincipal }}>{`${(editCita) ? 'Reserva' : 'Nueva reserva'}`}</h3>
                        </div>
                        {
                            hasAlertas &&
                            <div
                                className='btn-alerts'
                                style={{ backgroundColor: alertasActive ? '#343434' : '#282B2E' }}
                                onClick={() => setAlertasActive(true)}
                            >
                                <AlertasIcon color={colores.colorPrincipal} />
                            </div>
                        }
                        <div
                            className="btn-close"
                            style={{ backgroundColor: `#282B2E` }}
                            onClick={closeModal}
                        >
                            <CloseIcon color={colores.colorPrincipal} />
                        </div>
                    </div>
                    {
                        (!editActive && editCita && citaActive) &&
                        <div className='modal-info-body'>
                            <div className='modal-info-body-scroll'>
                            {(() => {
                                const servicioActual = citaActive.servicioActual;
                                
                                if (servicioActual) {
                                    const servicioId = servicioActual.servicio?._id || servicioActual.servicio;
                                    let servicio = resolverServicioEnCita(citaActive, servicioId, servicios);
                                    if (!servicio && servicioActual.nombre) {
                                        servicio = {
                                            _id: servicioId,
                                            nombre: servicioActual.nombre,
                                            precio: servicioActual.precio,
                                            duracion: servicioActual.duracionOriginal,
                                            duracion1: servicioActual.duracion1,
                                        };
                                    }
                                    if (!servicio) {
                                        servicio = citaActive.servicios?.find(referenciaServicio => {
                                            if (!referenciaServicio) return false;
                                            const servicioIdReferencia = referenciaServicio._id || referenciaServicio;
                                            return String(servicioIdReferencia) === String(servicioId);
                                        });
                                    }
                                    if (!servicio) return null;
                                    
                                    const fechaInicio = servicioActual.fechaInicio ? moment(servicioActual.fechaInicio) : moment(citaActive.fecha);
                                    const fechaFin = fechaInicio.clone().add(servicioActual.duracion || servicio.duracion || 0, 'minutes');
                                    const profesionalIdActual = servicioActual.profesional?._id || servicioActual.profesional;
                                    const profesionalActual = rdProfesionales.find(p => p && p._id && String(p._id) === String(profesionalIdActual));
                                    
                                    const idxServicio = citaActive.idxServicio !== undefined ? citaActive.idxServicio : 
                                        (citaActive.servicios ? citaActive.servicios.findIndex(sd => {
                                            const sdId = sd.servicio?._id || sd.servicio;
                                            return String(sdId) === String(servicioId);
                                        }) : -1);
                                    
                                    const esUltimoServicio = idxServicio >= 0 && citaActive.servicios && 
                                        idxServicio === citaActive.servicios.length - 1;
                                    
                                    let precioServicio = parseInt(servicio.precio || 0, 10);
                                    
                                    const servicioIdActual = servicio._id || servicio;
                                    const servicioIdActualStr = String(servicioIdActual);
                                    
                                    const variantesDelServicio = variantesCitaParaUI(citaActive, variantes, servicioIdActualStr);
                                    
                                    if (variantesDelServicio.length > 0) {
                                        const precioVariantes = variantesDelServicio.reduce((total, referenciaVariante) => {
                                            if (referenciaVariante.valor != null) {
                                                return total + (referenciaVariante.valor || 0);
                                            }
                                            const varianteId = referenciaVariante._id || referenciaVariante;
                                            const varianteCompleta = variantes.find(itemVariante => {
                                                const idVarianteCatalogo = itemVariante._id || itemVariante;
                                                return String(idVarianteCatalogo) === String(varianteId);
                                            });
                                            if (varianteCompleta && varianteCompleta.valor) {
                                                return total + (varianteCompleta.valor || 0);
                                            }
                                            return total;
                                        }, 0);
                                        precioServicio += precioVariantes;
                                    }
                                    
                                    const serviciosParaTotalesInfo = serviciosCitaParaUI(citaActive, servicios);
                                    const promosConImporteUI = citaActive.promociones?.filter(p => p.importeAplicado > 0) || [];
                                    if (promosConImporteUI.length > 0 && serviciosParaTotalesInfo.length > 0) {
                                        const numServicios = serviciosParaTotalesInfo.length;
                                        const precioTotalServicios = serviciosParaTotalesInfo.reduce((total, s) => {
                                            return total + parseInt(s.precio || 0, 10);
                                        }, 0);

                                        if (precioTotalServicios > 0) {
                                            const precioServicioBase = parseInt(servicio.precio || 0, 10);
                                            const proporcionServicio = precioServicioBase / precioTotalServicios;

                                            promosConImporteUI.forEach(promo => {
                                                const promoOrigen = promociones.find(p => String(p._id) === String(promo.promocion || promo._id));
                                                const descuentoServicio = calcularDescuentoServicioCentimos(
                                                    promo.importeAplicado,
                                                    { esCifra: !!(promoOrigen && promoOrigen.cifra), numServicios, proporcion: proporcionServicio }
                                                );
                                                precioServicio -= descuentoServicio;
                                            });
                                        }
                                    }
                                    
                                    if (citaActive.productos && citaActive.productos.length > 0) {
                                        const precioProductos = citaActive.productos.reduce((total, producto) => {
                                            return total + parseInt(producto.precio || 0, 10);
                                        }, 0);
                                        
                                        if (serviciosParaTotalesInfo.length > 0) {
                                            const precioTotalServicios = serviciosParaTotalesInfo.reduce((total, s) => {
                                                return total + parseInt(s.precio || 0, 10);
                                            }, 0);
                                            
                                            if (precioTotalServicios > 0) {
                                                const precioServicioBase = parseInt(servicio.precio || 0, 10);
                                                const proporcionServicio = precioServicioBase / precioTotalServicios;
                                                precioServicio += precioProductos * proporcionServicio;
                                            }
                                        }
                                    }
                                    
                                    precioServicio = precioServicio / 100;
                                    
                                    return (
                            <div className='modal-info-rows'>
                                <div className='modal-info-row'>
                                    <div className='icon'><ClientesIcon color="white" /></div>
                                    <p className='title'>Cliente:</p>
                                    {!!usuarioActivoResolved && <Link to={historyPath()}>
                                        <p className='info'>{usuarioActivoResolved?.nombre}</p>
                                        <p className='info'>{usuarioActivoResolved?.apellidos}</p>
                                                </Link>}
                                            </div>
                                            <div className='modal-info-row'>
                                                <div className='icon'><TelephoneIcon color="white" width='15' height='15' /></div>
                                                <p className='title'>Teléfono:</p>
                                                <p className='info'><a href={`tel:${usuarioActivoResolved?.telefono}`} style={{color: 'white'}}>{usuarioActivoResolved?.telefono}</a></p>
                                            </div>
                                            <div className='modal-info-row'>
                                                <div className='icon'><ServiciosIcon color="white" width='15' height='17' /></div>
                                                <p className='title'>Servicio:</p>
                                                <p className='info'>{nombreServicioDesdeDetalle(servicioActual, citaActive, servicios)}</p>
                                            </div>
                                            <div className='modal-info-row'>
                                                <div className='icon'><VariantesIcon color="white" width='15' height='17' /></div>
                                                {variantesDelServicio.length > 1 && <p className='title'>Variantes:</p>}
                                                {variantesDelServicio.length <= 1 && <p className='title'>Variantes:</p>}
                                                <div style={{
                                                    display: 'flex',
                                                    justifyContent: "center",
                                                    flexDirection: "column",
                                                }}>
                                                    {
                                                        variantesDelServicio.length > 0 ? (
                                                            variantesDelServicio.map((referenciaVariante) => {
                                                                const varianteId = referenciaVariante._id || referenciaVariante;
                                                                const nombreVarianteResuelto = nombreVarianteParaDisplay(referenciaVariante, citaActive, variantes)
                                                                    || variantes.find(itemVariante => String(itemVariante._id || itemVariante) === String(varianteId))?.nombre;
                                                                if (!nombreVarianteResuelto) return null;
                                                                return (
                                                                    <p key={varianteId} className='info'>
                                                                        {variantesDelServicio.length > 1 && "• "}{nombreVarianteResuelto}
                                                                    </p>
                                                                );
                                                            })
                                                        ) : (
                                                            <p className='info'>No hay variantes.</p>
                                                        )
                                                    }
                                                </div>
                                            </div>
                                            <div className='modal-info-row'>
                                                <div className='icon'><SucursalesIcon color="white" width='15' height='17' /></div>
                                                <p className='title'>Sucursal:</p>
                                                <p className='info'>{citaActive.sucursal?.nombre || citaActive.sucursal}</p>
                                            </div>
                                            <div className='modal-info-row'>
                                                <div className='icon'><ProfesionalesIcon color="white" width='15' height='17' /></div>
                                                <p className='title'>Profesional:</p>
                                                <p className='info'>{profesionalActual?.nombre || 'Profesional'}</p>
                                            </div>
                                            <div className='modal-info-row'>
                                                <div className='icon'><ReservasIcon color="white" width='15' height='17' /></div>
                                                <p className='title'>Fecha:</p>
                                                <p className='info'>{fechaInicio.format('DD/MM/YYYY')}</p>
                                            </div>
                                            <div className='modal-info-row'>
                                                <div className='icon'><ClockAlertIcon color="white" width='15' height='17' /></div>
                                                <p className='title'>Hora:</p>
                                                <p className='info'>{fechaInicio.format('H:mm')} - {fechaFin.format('H:mm')}h.</p>
                                            </div>
                                            <div className='modal-info-row'>
                                                <div className='icon'><EuroIcon color="white" width='15' height='17' /></div>
                                                <p className='title'>Precio:</p>
                                                <p className='info'>
                                                    {(() => {
                                                        const ventaBlock = servicioActual?.venta;
                                                        const importeBlock = (ventaBlock && typeof ventaBlock === 'object' && ventaBlock.importe != null)
                                                            ? Number(ventaBlock.importe)
                                                            : null;
                                                        return (importeBlock != null ? importeBlock.toFixed(2) : precioServicio.toFixed(2)) + '€';
                                                    })()}
                                                </p>
                                            </div>
                                        </div>
                                    );
                                }
                                
                                return (
                                    <div className='modal-info-rows'>
                                        <div className='modal-info-row'>
                                            <div className='icon'><ClientesIcon color="white" /></div>
                                            <p className='title'>Cliente:</p>
                                            {!!usuarioActivoResolved && <Link to={historyPath()}>
                                                <p className='info'>{usuarioActivoResolved?.nombre}</p>
                                                <p className='info'>{usuarioActivoResolved?.apellidos}</p>
                                    </Link>}
                                </div>
                                <div className='modal-info-row'>
                                    <div className='icon'><TelephoneIcon color="white" width='15' height='15' /></div>
                                    <p className='title'>Teléfono:</p>
                                    <p className='info'><a href={`tel:${usuarioActivoResolved?.telefono}`} style={{color: 'white'}}>{usuarioActivoResolved?.telefono}</a></p>
                                </div>
                                <div className='modal-info-row'>
                                    <div className='icon'><ServiciosIcon color="white" width='15' height='17' /></div>
                                            {citaActive.servicios && citaActive.servicios.length > 1 && <p className='title'>Servicios:</p>}
                                            {(!citaActive.servicios || citaActive.servicios.length === 1) && <p className='title'>Servicio:</p>}
                                    <div style={{
                                        display: 'flex',
                                        justifyContent: "center",
                                        flexDirection: "column",
                                    }}>
                                        {
                                                    (() => {
                                                        if (citaActive.servicios && citaActive.servicios.length > 0) {
                                                            return citaActive.servicios.map((servicioDetalle, idx) => {
                                                                if (!servicioDetalle) return null;
                                                                
                                                                const servicioId = servicioDetalle.servicio?._id || servicioDetalle.servicio;
                                                                let servicio = resolverServicioEnCita(citaActive, servicioId, servicios)
                                                                    || citaActive.servicios?.find(referenciaServicio => {
                                                                    if (!referenciaServicio) return false;
                                                                    const servicioIdReferencia = referenciaServicio._id || referenciaServicio;
                                                                    return String(servicioIdReferencia) === String(servicioId);
                                                                }) || citaActive.servicios?.[idx];
                                                                const nombreServBloque = nombreServicioDesdeDetalle(servicioDetalle, citaActive, servicios);
                                                                if (!servicio && nombreServBloque === 'Servicio') return null;
                                                                
                                                                const fechaInicio = servicioDetalle.fechaInicio ? moment(servicioDetalle.fechaInicio) : moment(citaActive.fecha);
                                                                const fechaFin = fechaInicio.clone().add(servicioDetalle.duracion || servicio?.duracion || 0, 'minutes');
                                                                const profesionalServicio = rdProfesionales.find(p => {
                                                                    const profesionalId = servicioDetalle.profesional?._id || servicioDetalle.profesional;
                                                                    return p && p._id && String(p._id) === String(profesionalId);
                                                                });
                                                                
                                                                const esBloqueSeleccionado = citaActive.servicioActual && String(servicioDetalle?.servicio?._id || servicioDetalle?.servicio) === String(citaActive.servicioActual?.servicio?._id || citaActive.servicioActual?.servicio);
                                                                return (
                                                                    <div
                                                                        key={idx}
                                                                        role={citaActive.servicios.length > 1 ? 'button' : undefined}
                                                                        tabIndex={citaActive.servicios.length > 1 ? 0 : undefined}
                                                                        onClick={citaActive.servicios.length > 1 ? async () => {
                                                                            const sinVariantes = !citaActive.variantes || citaActive.variantes.length === 0;
                                                                            if (sinVariantes && empresa) {
                                                                                await dispatch(getCita(citaActive._id, empresa, { servicioActual: servicioDetalle }));
                                                                            } else {
                                                                                dispatch(activeCita(citaActive._id, { ...citaActive, servicioActual: servicioDetalle }));
                                                                            }
                                                                        } : undefined}
                                                                        onKeyDown={citaActive.servicios.length > 1 ? (e) => {
                                                                            if (e.key === 'Enter' || e.key === ' ') {
                                                                                e.preventDefault();
                                                                                const sinVar = !citaActive.variantes || citaActive.variantes.length === 0;
                                                                                if (sinVar && empresa) dispatch(getCita(citaActive._id, empresa, { servicioActual: servicioDetalle }));
                                                                                else dispatch(activeCita(citaActive._id, { ...citaActive, servicioActual: servicioDetalle }));
                                                                            }
                                                                        } : undefined}
                                                                        style={{
                                                                            display: 'flex',
                                                                            alignItems: 'center',
                                                                            gap: '8px',
                                                                            marginBottom: '4px',
                                                                            ...(citaActive.servicios.length > 1 ? { cursor: 'pointer', borderRadius: '4px', padding: '4px 0', background: esBloqueSeleccionado ? 'rgba(255,255,255,0.1)' : undefined } : {})
                                                                        }}
                                                                    >
                                                                        <p className='info' style={{ margin: 0, flex: 1, marginLeft: '8px' }}>
                                                                            {citaActive.servicios.length > 1 && "• "}
                                                                            {nombreServBloque} 
                                                                            {fechaInicio.isValid() && ` (${fechaInicio.format('H:mm')} - ${fechaFin.format('H:mm')})`}
                                                                            {profesionalServicio && ` - ${profesionalServicio.nombre}`}
                                                                        </p>
                                                                    </div>
                                                                );
                                                            }).filter(item => item !== null);
                                                        } else if (citaActive.servicios && Array.isArray(citaActive.servicios)) {
                                                            const serviciosDesdeSnapshotUI = serviciosCitaParaUI(citaActive, servicios);
                                                            const serviciosParaListado = serviciosDesdeSnapshotUI.length > 0 ? serviciosDesdeSnapshotUI : citaActive.servicios;
                                                            return serviciosParaListado.map((servicio) => (
                                                                <p key={servicio?._id || Math.random()} className='info' style={{ marginLeft: '8px' }}>
                                                                    {serviciosParaListado.length > 1 && "• "}{servicio?.nombre || 'Servicio'}
                                                                </p>
                                                            ));
                                                        } else {
                                                            return <p className='info' style={{ marginLeft: '8px' }}>No hay servicios disponibles</p>;
                                                        }
                                                    })()
                                        }
                                    </div>
                                </div>
                                <div className='modal-info-row'>
                                    <div className='icon'><VariantesIcon color="white" width='15' height='17' /></div>
                                    {citaActive.variantes && citaActive.variantes.length > 1 && <p className='title'>Variantes:</p>}
                                    {(!citaActive.variantes || citaActive.variantes.length <= 1) && <p className='title'>Variantes:</p>}
                                    <div style={{
                                        display: 'flex',
                                        justifyContent: "center",
                                        flexDirection: "column",
                                    }}>
                                        {
                                            (() => {
                                                const variantesDesdeSnapshotUI = variantesCitaParaUI(citaActive, variantes);
                                                const variantesParaListado = variantesDesdeSnapshotUI.length > 0 ? variantesDesdeSnapshotUI : (citaActive.variantes || []);
                                                if (variantesParaListado.length === 0) {
                                                    return <p className='info'>No hay variantes.</p>;
                                                }
                                                return variantesParaListado.map((referenciaVariante) => {
                                                    const varianteId = referenciaVariante && (referenciaVariante._id || referenciaVariante);
                                                    const nombreVarianteResuelto = nombreVarianteParaDisplay(referenciaVariante, citaActive, variantes)
                                                        || variantes.find(itemVariante => String(itemVariante._id || itemVariante) === String(varianteId))?.nombre;
                                                    if (!nombreVarianteResuelto) return null;
                                                    return (
                                                        <p key={varianteId} className='info'>
                                                            {variantesParaListado.length > 1 && "• "}{nombreVarianteResuelto}
                                                        </p>
                                                    );
                                                });
                                            })()
                                        }
                                    </div>
                                </div>
                                <div className='modal-info-row'>
                                    <div className='icon'><SucursalesIcon color="white" width='15' height='17' /></div>
                                    <p className='title'>Sucursal:</p>
                                            <p className='info'>{citaActive.sucursal?.nombre || citaActive.sucursal}</p>
                                </div>
                                <div className='modal-info-row'>
                                    <div className='icon'><ProfesionalesIcon color="white" width='15' height='17' /></div>
                                    <p className='title'>Profesional:</p>
                                    <p className='info'>
                                        {(() => {
                                            const prof = citaActive.servicioActual?.profesional != null
                                                ? (typeof citaActive.servicioActual.profesional === 'object' && citaActive.servicioActual.profesional?.nombre
                                                    ? citaActive.servicioActual.profesional.nombre
                                                    : (rdProfesionales.find(p => p && (String(p._id) === String(citaActive.servicioActual.profesional?._id || citaActive.servicioActual.profesional)))?.nombre))
                                                : citaActive.profesional?.nombre;
                                            return prof || 'Profesional';
                                        })()}
                                    </p>
                                </div>
                                <div className='modal-info-row'>
                                    <div className='icon'><ReservasIcon color="white" width='15' height='17' /></div>
                                    <p className='title'>Fecha:</p>
                                    <p className='info'>{moment((citaActive.servicioActual?.fechaInicio || citaActive.fecha)).format('DD/MM/YYYY')}</p>
                                </div>
                                <div className='modal-info-row'>
                                    <div className='icon'><ClockAlertIcon color="white" width='15' height='17' /></div>
                                    <p className='title'>Hora:</p>
                                    <p className='info'>{moment((citaActive.servicioActual?.fechaInicio || citaActive.fecha)).format('H:mm')}h.</p>
                                </div>
                                <div className='modal-info-row'>
                                    <div className='icon'><PreciosEspecialesIcon color="white" /></div>
                                    <p className='title'>Descuentos:</p>
                                    {
                                        citaActive.promociones.length > 0 ?
                                            promociones.filter(p => citaActive.promociones.includes(p._id)).map((promocion) => (
                                                <p key={promocion._id} className='info'>
                                                    {promocion.titulo} -{promocion.porcentaje ? promocion.porcentaje / 100 + '%' : promocion.cifra / 100 + '€'}
                                                </p>
                                            ))
                                            :
                                            <p className='info'>No</p>
                                    }
                                </div>
                                <div className='modal-info-row'>
                                    <div className='icon'><EuroIcon color="white" width='15' height='17' /></div>
                                    <p className='title'>Precio:</p>
                                    <p className='info'>
                                        {(() => {
                                            if (citaActive.venta && (typeof citaActive.venta === 'object') && citaActive.venta.importe != null) {
                                                return Number(citaActive.venta.importe).toFixed(2);
                                            }
                                            if (citaActive.importe != null && ((!citaActive.promociones || citaActive.promociones.length === 0) || citaActive.promociones?.some(p => p.importeAplicado > 0))) {
                                                return Number(citaActive.importe).toFixed(2);
                                            }
                                            if (citaActive.promociones && citaActive.promociones.length > 0 && citaActive.servicios && citaActive.servicios.length > 0) {
                                                let precioBase = citaActive.servicios.reduce((t, s) => t + parseInt(s.precio || 0, 10), 0);
                                                const variantesValor = (citaActive.variantes || []).reduce((t, vId) => {
                                                    const v = variantes.find(vr => String(vr._id || vr) === String(vId._id || vId));
                                                    return t + (v && v.valor ? parseInt(v.valor, 10) : 0);
                                                }, 0);
                                                precioBase += variantesValor;
                                                const rawPromo = [citaActive.promociones].flat();
                                                rawPromo.forEach(p => {
                                                    const id = p && (p._id || p);
                                                    const promo = id ? promociones.find(pr => String(pr._id || pr) === String(id)) : (p && typeof p === 'object' ? p : null);
                                                    if (promo) {
                                                        const descImpte = calculaImporteDescuentos(promo, citaActive.servicios);
                                                        precioBase -= parseFloat(descImpte || 0);
                                                    }
                                                });
                                                const productosValor = (citaActive.productos || []).reduce((t, p) => {
                                                    if (!p || typeof p !== 'object') return t;
                                                    return t + parseInt(p.precio || 0, 10);
                                                }, 0);
                                                precioBase += productosValor;
                                                return (precioBase / 100).toFixed(2);
                                            }
                                            return citaActive.importe != null ? Number(citaActive.importe).toFixed(2) : '0.00';
                                        })()}€
                                    </p>
                                </div>
                                {/* EX-515: desglose por método cuando hay múltiples ventas */}
                                {Array.isArray(citaActive.ventas) && citaActive.ventas.filter(v => !['Anulación venta', 'Anulación cita'].includes(v?.metodoPago)).length > 1 && (
                                    <div className='modal-info-row modal-info-row--multipago'>
                                        <div className='icon'><EuroIcon color="white" width='15' height='17' /></div>
                                        <p className='title'>Pagos:</p>
                                        <div className='info' style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                                            {citaActive.ventas
                                                .filter(v => !['Anulación venta', 'Anulación cita'].includes(v?.metodoPago))
                                                .map((venta, idx) => (
                                                    <span key={venta._id || idx}>
                                                        {Number(venta.importe || 0).toFixed(2)}€ {venta.metodoPago}
                                                    </span>
                                                ))}
                                        </div>
                                    </div>
                                )}
                            </div>
                                );
                            })()}
                            </div>
                            <footer className='modal-info-footer'>
                                <div className='btn-row multiple'>
                                    <div 
                                        className={(() => {
                                            if (citaActive.pagada) return 'info-btn paid';
                                            const esMonederoSucursalPendiente = citaActive.venta && !citaActive.pagada && String(citaActive.metodoPago || '').includes('Monedero App') && String(citaActive.metodoPago || '').includes('Pago en sucursal');
                                            const esMultiservicio = (citaActive.servicios?.length > 1 || citaActive.servicios?.length > 1);
                                            if (esMultiservicio && citaActive.servicioActual) {
                                                const bloqueActualPagado = citaActive.servicioActual.pagada === true;
                                                return esMonederoSucursalPendiente ? 'info-btn pay' : (bloqueActualPagado ? 'info-btn paid' : 'info-btn pay');
                                            }
                                            return 'info-btn pay';
                                        })()}
                                        onClick={async () => {
                                            const esMonederoSucursalPendiente = !citaActive.pagada && citaActive.venta && String(citaActive.metodoPago || '').includes('Monedero App') && String(citaActive.metodoPago || '').includes('Pago en sucursal');
                                            if (citaActive?.servicios?.length > 1 || citaActive?.servicios?.length > 1) {
                                                const servicioActual = citaActive.servicioActual;
                                                const primeroNoPagado = citaActive.servicios?.find(sd => !sd.pagada);
                                                const detalleAPagar = servicioActual || primeroNoPagado || citaActive.servicios?.[0];
                                                if (detalleAPagar) {
                                                    if (empresa) {
                                                        await dispatch(getCita(citaActive._id, empresa, { servicioActual: detalleAPagar }));
                                                    } else {
                                                        dispatch(activeCita(citaActive._id, { ...citaActive, servicioActual: detalleAPagar }));
                                                    }
                                                }
                                                setVentaModoCitaCompleta(false);
                                                setActiveModalVentas(true);
                                                setActiveModalReserva(false);
                                            } else if (esMonederoSucursalPendiente && empresa) {
                                                await dispatch(getCita(citaActive._id, empresa));
                                                setVentaModoCitaCompleta(true);
                                                setActiveModalVentas(true);
                                                setActiveModalReserva(false);
                                            } else {
                                                setVentaModoCitaCompleta(false);
                                                setActiveModalVentas(true);
                                                setActiveModalReserva(false);
                                            }
                                        }}
                                        title="Pagar por servicio"
                                    >
										
                                        <EuroIcon color="white" width="12" height='16'/>
                                    </div>
                                    <div
                                        className='info-btn'
                                        onClick={handleEditarCita}
                                    >
                                        <EditarIcon color="white" width="12" height='16' />
                                    </div>
                                    <div
                                        className='info-btn'
                                        onClick={() => clickEliminar(citaActive)}
                                    >
                                        <TrashIcon color="white" width="17" height='18' />
                                    </div>
                                    {citaActive?.venta && (
                                        <div
                                            className='info-btn'
                                            onClick={!enviandoTicket ? handleEnviarTicket : undefined}
                                            title="Enviar ticket"
                                            style={{ position: 'relative', opacity: enviandoTicket ? 0.6 : 1, cursor: enviandoTicket ? 'not-allowed' : 'pointer' }}
                                        >
                                            <MailIcon color="white" />
                                            {citaActive?.ticketEnviado && !enviandoTicket && (
                                                <span style={{ position: 'absolute', top: '-4px', right: '-4px', width: '10px', height: '10px', borderRadius: '50%', backgroundColor: '#96F8D2' }} />
                                            )}
                                        </div>
                                    )}
                                </div>
                                {!citaActive?.venta && (citaActive?.servicios?.length > 1 || citaActive?.servicios?.length > 1) && !citaActive?.servicios?.some(sd => sd.pagada) && (
                                    <div className='btn-row single btn-row-pagar-completa'>
                                        <button
                                            type="button"
                                            className='info-btn pay-cita-completa'
                                            onClick={() => {
                                                dispatch(getCita(citaActive._id, empresa)).then(() => {
                                                    setVentaModoCitaCompleta(true);
                                                    setActiveModalVentas(true);
                                                    setActiveModalReserva(false);
                                                });
                                            }}
                                        >
                                            Pagar cita completa
                                        </button>
                                    </div>
                                )}
                                <div className='btn-row single'>
                                    <div
                                        className='no-date'
                                        onClick={() => clickNoPresentado()}
                                    >No se ha presentado a la cita</div>
                                </div>
                            </footer>
                        </div>
                    }
                    <div className="modal-reserva__body">
                    {(editActive || !editCita) && (
                        <div className="modal-reserva__cols">
                            <div className="modal-reserva__mobile-service">
                                <div className="modal-body modal-body--underline-inputs">
                                    <DropdownMultipleServicios
                                        key={activeModalReserva ? 'servicios-open' : 'servicios-closed'}
                                        services={filteredServices}
                                        selectedServices={selectedServices}
                                        handleServicesChanged={handleServicesChanged}
                                        editCita={editCita}
                                        variant="dropdown"
                                    />
                                </div>
                            </div>
                            <div className="modal-reserva__col-left">
                                <div className="modal-body modal-body--services">
                                    <DropdownMultipleServicios
                                        key={activeModalReserva ? 'servicios-open' : 'servicios-closed'}
                                        services={filteredServices}
                                        selectedServices={selectedServices}
                                        handleServicesChanged={handleServicesChanged}
                                        editCita={editCita}
                                        variant="cards"
                                    />
                                </div>
                            </div>
                            <div className="modal-reserva__col-middle">
                                <div className="modal-body modal-body--underline-inputs">
                            {
                                editNotesOnly ? (
                                    <>
                                        <div className='modal-info-row'>                                
                                            <p className='title'>Cliente:</p>
                                            <p className='info'>{usuarioActivoResolved?.nombre || 'N/A'} {usuarioActivoResolved?.apellidos || ''}</p>
                                        </div>
                                        <div className="brb-text">
                                            <a href={`tel:+34${usuarioActivoResolved?.telefono || ''}`}>
                                                {usuarioActivoResolved?.telefono || "Teléfono del cliente"}
                                            </a>
                                        </div>
                                        {(citaActive?.servicioActual?.servicio ?? citaActive?.servicios?.[0] ?? citaActive?.servicio ?? servicioActive) && (
                                            <div className='modal-info-row'>
                                                <div className='icon'><ServiciosIcon color="white" width='15' height='17' /></div>
                                                <p className='title'>Servicio:</p>
                                                <p className='info'>{((citaActive?.servicioActual?.servicio ?? citaActive?.servicios?.[0] ?? citaActive?.servicio ?? servicioActive)?.nombre) || 'Servicio'}</p>
                                            </div>
                                        )}
                                        {sucursalActive && (
                                            <div className='modal-info-row'>
                                                <div className='icon'><SucursalesIcon color="white" width='15' height='17' /></div>
                                                <p className='title'>Sucursal:</p>
                                                <p className='info'>{sucursalActive.nombre || 'N/A'}</p>
                                            </div>
                                        )}
                                        {profesionalActive && (
                                            <div className='modal-info-row'>
                                                <div className='icon'><ProfesionalesIcon color="white" width='15' height='17' /></div>
                                                <p className='title'>Profesional:</p>
                                                <p className='info'>{profesionalActive.nombre || 'N/A'}</p>
                                            </div>
                                        )}
                                        {citaActive?.fecha && (
                                            <>
                                                <div className='modal-info-row'>
                                                    <div className='icon'><ReservasIcon color="white" width='15' height='17' /></div>
                                                    <p className='title'>Fecha:</p>
                                                    <p className='info'>{moment(citaActive.fecha).format('DD/MM/YYYY')}</p>
                                                </div>
                                                <div className='modal-info-row'>
                                                    <div className='icon'><ClockAlertIcon color="white" width='15' height='17' /></div>
                                                    <p className='title'>Hora:</p>
                                                    <p className='info'>{moment(citaActive.fecha).format('H:mm')}h.</p>
                                                </div>
                                            </>
                                        )}
                                        <div className="comment-field">
                                            <div className="text-area">
                                                <textarea
                                                    id="comentario-reserva"
                                                    name="comentario-reserva"
                                                    placeholder="Comentario de la reserva (opcional)"
                                                    value={txtComentario}
                                                    onChange={(e) => setTxtComentario(e.target.value)}
                                                />
                                            </div>
                                        </div>
                                        <div
                                            className="btn btn-reservar"
                                            style={{ backgroundColor: colores.colorPrincipal }}
                                            onClick={handleEditNotesOnly}
                                        >
                                            <p>Guardar comentarios</p>
                                        </div>
                                    </>
                                ) : (
                                    <>
                                        {
                                            (fromGestion)
                                            ?
                                            <>
                                                <DropdownClientes
                                                    usuarios={usuarios}
                                                    texto="Selecciona cliente"
                                                    handleUsuarioSelected={handleUsuarioSelected}
                                                    selectUsuario={selectUsuario}
                                                    editCita={editCita}
                                                />
                                                {usuarioActivoResolved &&
                                                <p className='info modal-reserva__saldo' style={{ textAlign: 'right', color: colores.colorSecundario, fontSize: '12px' }}>
                                                    &nbsp;Saldo disponible: {usuarioActivoResolved?.saldoMonedero ? usuarioActivoResolved?.saldoMonedero?.toFixed(2) + '€' : '0.00€'}
                                                </p>
                                                }
                                            </>
                                            :
                                            <div className='modal-info-row'>                                
                                                <p className='title'>Cliente:</p>
                                                {!!usuarioActivoResolved && <Link to={historyPath()}>
                                                    <p className='info'>&nbsp;{usuarioActivoResolved?.nombre} {usuarioActivoResolved?.apellidos}</p>
                                                   
                                                </Link>}
                                            </div>
                                        }
                                        <div className="brb-text">
                                            <input
                                                type="tel"
                                                className="brb-text__input"
                                                value={telefonoReserva}
                                                onChange={e => setTelefonoReserva(e.target.value)}
                                                placeholder="Teléfono del cliente"
                                            />
                                        </div>
                                        <MultiSelectionVariantes
                                            variantes={variantes}
                                            selectedServicio={selectedServices}
                                            selectedVariantes={selectedVariantes}
                                            handleVariantesChanged={handleVariantesChanged}
                                            variant="chips"
                                        />

                                        {
                                            citaActive?.pagada &&
                                            <div className='cita-pagada'>
                                                <PagoAdelantadoIcon />
                                                <p>Pagado por adelantado</p>
                                            </div>
                                        }
                                        {
                                            citaActive?.confirmada && citaActive?.prepago && !citaActive?.pagada &&
                                            <div className='cita-pagada'>
                                                <PagoAdelantadoIcon />
                                                <p>Saldo cargado, pendiente cobro</p>
                                            </div>
                                        }
                                        <DropdownSucursales
                                            selectServicio={selectedServices}
                                            texto="Selecciona la sucursal"
                                            handleSucursalSelected={handleSucursalSelected}
                                            selectSucursal={selectSucursal}
                                            editCita={editCita}
                                            variant="pills"
                                        />
                                        {
                                            selectedServices.length === 1 && selectSucursal.selected && (
                                                <DropdownProfesionales
                                                    selectServicio={selectedServices}
                                                    selectSucursal={selectSucursal}
                                                    profesionales={profesionales}
                                                    profesionalesDisabled={profesionalesDisabled}
                                                    texto="Selecciona profesional"
                                                    handleProfesionalSelected={handleProfesionalSelected}
                                                    selectProfesional={selectProfesional}
                                                    citaActive={citaActive}
                                                    fromGestion={fromGestion}
                                                    variant="avatares"
                                                />
                                            )
                                        }
                                        {
                                            selectedServices.length > 1 && selectSucursal.selected && selectedServices.map((servicio, idx) => {
                                                const servicioId = servicio._id;
                                                const horaElegida = timeCalendar && moment(timeCalendar).year() !== 1972 && selectTime.touched;
                                                const tieneHoraPrimerServicio = horaElegida && profesionalesPorServicio[selectedServices[0]?._id];
                                                if (idx > 0 && !tieneHoraPrimerServicio) return null;
                                                const listaBase = profesionalesPorServicioLista[servicioId] || profesionales || [];
                                                const profesionalesDisponibles = listaBase.filter((p) => {
                                                    if (p._id === '333') return true;
                                                    if (p.deleted) return false;
                                                    if (!p.sucursales?.includes(selectSucursal.selected?._id)) return false;
                                                    if (p.servicios && p.servicios.length > 0) {
                                                        return p.servicios.some((s) => {
                                                            const sId = s._id || s;
                                                            return String(sId) === String(servicioId);
                                                        });
                                                    }
                                                    return true;
                                                });
                                                const aleatorioPrimero = profesionalesDisponibles.find((p) => p._id === '333');
                                                const resto = profesionalesDisponibles.filter((p) => p._id !== '333');
                                                const list = aleatorioPrimero ? [aleatorioPrimero, ...resto] : profesionalesDisponibles;
                                                const selectedId = profesionalesPorServicio[servicioId] || null;
                                                if (list.length === 0) return null;
                                                return (
                                                    <div key={servicioId} className="profesional-avatares" data-servicio-index={idx}>
                                                        <p className="profesional-avatares__label">{servicio.nombre}</p>
                                                        <div className="profesional-avatares__row">
                                                            {list.map((prof) => {
                                                                const isAleatorio = prof._id === '333' || prof._id === 333;
                                                                const isSelected = isAleatorio ? (selectedId === '333' || selectedId === 333) : (selectedId && String(prof._id) === String(selectedId));
                                                                return (
                                                                    <button
                                                                        key={prof._id}
                                                                        type="button"
                                                                        className={`profesional-avatares__item ${isSelected ? 'profesional-avatares__item--selected' : ''}`}
                                                                        style={{ borderColor: isSelected ? colores?.colorPrincipal : undefined }}
                                                                        onClick={() => {
                                                                            const next = { ...profesionalesPorServicio };
                                                                            next[servicioId] = prof._id;
                                                                            setProfesionalesPorServicio(next);
                                                                            if (selectDate.visible && !editCita) {
                                                                                setSelectTime((st) => ({ ...st, visible: true }));
                                                                                setTimeout(() => getMorningAfternoon(), 100);
                                                                            }
                                                                        }}
                                                                        title={prof.nombre}
                                                                    >
                                                                        <div
                                                                            className="profesional-avatares__avatar"
                                                                            style={{
                                                                                backgroundColor: isSelected ? colores?.colorPrincipal : undefined,
                                                                                backgroundImage: prof.img?.[0] ? `url(${prof.img[0]})` : undefined,
                                                                            }}
                                                                        >
                                                                            {!prof.img?.[0] && (
                                                                                <span className="profesional-avatares__initials">
                                                                                    {isAleatorio ? '?' : getInitials(prof.nombre)}
                                                                                </span>
                                                                            )}
                                                                            {isAleatorio && isSelected && (
                                                                                <span className="profesional-avatares__badge">Live</span>
                                                                            )}
                                                                        </div>
                                                                        <span className="profesional-avatares__nombre">
                                                                            {isAleatorio ? 'Aleatorio' : prof.nombre}
                                                                        </span>
                                                                    </button>
                                                                );
                                                            })}
                                                        </div>
                                                    </div>
                                                );
                                            })
                                        }
                                    </>
                                )}
                                </div>
                            </div>
                            {!editNotesOnly && (
                            <div className="modal-reserva__col-right">
                                <div className="modal-body modal-body--underline-inputs">
                                        <DropdownDate
                                            selectDate={selectDate}
                                            setSelectDate={setSelectDate}
                                            fechaCalendar={fechaCalendar}
                                            setFechaCalendar={setFechaCalendar}
                                            timeCalendar={timeCalendar}
                                            setTimeCalendar={setTimeCalendar}
                                            variant="inline"
                                        />
                                        <DropdownTime
                                                activeModalReserva={activeModalReserva}
                                                selectTime={selectTime}
                                                setSelectTime={setSelectTime}
                                                timeCalendar={timeCalendar}
                                                setTimeCalendar={setTimeCalendar}
                                                selectServicio={selectServicio}
                                                selectSucursal={selectSucursal}
                                                profesionales={profesionales}
                                                setProfesionales={setProfesionales}
                                                selectProfesional={selectProfesional}
                                                setProfSelected={setProfSelected}
                                                fechaCalendar={fechaCalendar}
                                                setFechaCalendar={setFechaCalendar}
                                                descuentosHorario={descuentosHorario}
                                                setDescuentosHorario={setDescuentosHorario}
                                                morning={morning}
                                                afternoon={afternoon}
                                                editCita={editCita}
                                                fromAdmin={true}
                                                isLoadingAvailability={isLoadingAvailability}
                                                hasAttemptedAvailability={hasAttemptedAvailability}
                                                availabilityWaitingMessage={
                                                    selectedServices.length === 0
                                                        ? 'Selecciona un servicio para ver los horarios disponibles'
                                                        : selectedServices.length === 1 && selectSucursal.selected && !selectProfesional?.selected
                                                            ? 'Selecciona un profesional para ver los horarios disponibles'
                                                            : selectedServices.length > 1 && selectSucursal.selected && selectedServices.some((s) => !profesionalesPorServicio[s._id])
                                                                ? 'Elige un profesional por servicio'
                                                                : null
                                                }
                                                label={selectedServices.length > 0 && selectedServices[0]?.nombre ? `Horarios: ${selectedServices[0].nombre}` : 'Horarios'}
                                                variant="inline"
                                                onTimeOutOfRange={() => setTimeCalendar(new Date(1972, 10, 13, 0, 0))}
                                            />
                                        {timeCalendar && moment(timeCalendar).year() !== 1972 && selectTime.touched && selectedServices.length > 1 && (
                                        <>
                                            {selectedServices.slice(1).map((servicio, idx) => {
                                            const sid = servicio._id;
                                            const slotsServicio = morningPorServicio[sid] || [];
                                            const timeServicio = timeCalendarPorServicio[sid];
                                            const selectTimeServicio = selectTimePorServicio[sid] || { visible: true, touched: false };
                                            const setTimeServicio = (date) => setTimeCalendarPorServicio(prev => ({ ...prev, [sid]: date }));
                                            const setSelectTimeServicio = (st) => setSelectTimePorServicio(prev => ({ ...prev, [sid]: st }));
                                            return (
                                                <div key={sid} className="dropdown-time-inline dropdown-time-inline--servicio-n" data-horario-index={idx}>
                                                    <label className="dropdown-time-inline__label">
                                                        Horarios: {servicio.nombre || `Servicio ${idx + 2}`}
                                                    </label>
                                                    <div className="dropdown-time-inline__content">
                                                        <HorarioSelect
                                                            activeModalReserva={activeModalReserva}
                                                            selectSucursal={selectSucursal}
                                                            profesionales={profesionales}
                                                            setProfesionales={setProfesionales}
                                                            selectProfesional={selectProfesional}
                                                            setProfSelected={() => {}}
                                                            fechaCalendar={fechaCalendar}
                                                            timeCalendar={timeServicio || new Date(1972, 10, 13, 0, 0)}
                                                            setTimeCalendar={setTimeServicio}
                                                            selectTime={selectTimeServicio}
                                                            setSelectTime={setSelectTimeServicio}
                                                            morning={slotsServicio}
                                                            afternoon={[]}
                                                            editCita={editCita}
                                                            isLoadingAvailability={isLoadingSlotsPorServicio[sid]}
                                                            hasAttemptedAvailability={!!timeCalendar}
                                                            availabilityWaitingMessage={null}
                                                            disableInitialReset={true}
                                                        />
                                                    </div>
                                                </div>
                                            );
                                        })}
                                        </>
                                        )}
                                        <div className="comment-field">
                                            <div className="text-area">
                                                <textarea
                                                    id="comentario-reserva"
                                                    name="comentario-reserva"
                                                    placeholder="Comentario de la reserva (opcional)"
                                                    value={txtComentario}
                                                    onChange={(e) => setTxtComentario(e.target.value)}
                                                />
                                            </div>
                                        </div>
                            {
                                !editNotesOnly && (
                                    (editCita)
                                    ?
                                    <>
                                        <div
                                            className="btn btn-reservar"
                                            style={{ backgroundColor: colores.colorPrincipal }}
                                            onClick={handleEditCita}
                                        >
                                            <p>Cambiar reserva</p>
                                        </div>
                                        <div
                                            className="btn btn-eliminar"
                                            style={{ backgroundColor: colores.color6, color: colores.colorPrincipal }}
                                            onClick={() => clickEliminar(citaActive)}
                                        >
                                            <p>Eliminar reserva</p>
                                        </div>
                                    </>
                                    :
                                    <button
                                        type="button"
                                        className="btn btn-editar"
                                        style={{
                                            backgroundColor: colores.colorPrincipal,
                                            opacity: (registerFormOk && !isCreatingCita) ? 1 : 0.5,
                                            cursor: (registerFormOk && !isCreatingCita) ? 'pointer' : 'inherit',
                                            color: '#fff'
                                        }}
                                        disabled={isCreatingCita}
                                        onClick={() => clickReservar(false)}
                                    >
                                        {isCreatingCita
                                            ? <span style={{ width: 20, height: 20, border: '3px solid rgba(255,255,255,0.3)', borderTop: '3px solid #fff', borderRadius: '50%', display: 'inline-block', animation: 'spin 0.6s linear infinite' }} />
                                            : <p>Crear reserva nueva</p>
                                        }
                                    </button>
                                )
                            }
                            {(formErrores.cliente || formErrores.servicio || formErrores.sucursal || formErrores.profesional || formErrores.hora) && (
                            <div
                                className="errores"
                            >
                                <div style={{ backgroundColor: colores.colorPrincipal }} className={`error ${(formErrores.cliente) ? 'active' : ''}`}>Selecciona un cliente</div>
                                <div style={{ backgroundColor: colores.colorPrincipal }} className={`error ${(formErrores.servicio) ? 'active' : ''}`}>Selecciona un servicio</div>
                                <div style={{ backgroundColor: colores.colorPrincipal }} className={`error ${(formErrores.sucursal) ? 'active' : ''}`}>Selecciona una barbería</div>
                                <div style={{ backgroundColor: colores.colorPrincipal }} className={`error ${(formErrores.profesional) ? 'active' : ''}`}>Selecciona un profesional</div>
                                <div style={{ backgroundColor: colores.colorPrincipal }} className={`error ${(formErrores.hora) ? 'active' : ''}`}>Selecciona una hora</div>
                            </div>
                            )}
                        </div>
                            </div>
                            )}
                        </div>
                    )}
                    {alertasActive && (
                        <div
                            className='alerts-body'
                            style={{ backgroundColor: !alertasActive ? '#282B2E' : '#343434' }}
                        >
                            {
                                (citaActive?.servicioActual?.isProfesionalRandom === true
                                    || (!citaActive?.servicioActual && citaActive?.isProfesionalRandom)
                                    || (citaActive?.isProfesionalRandom && (!citaActive?.servicios || citaActive.servicios.length <= 1 || citaActive.idxServicio === 0))) &&
                                <div className='alert-item random'>
                                    <div className='alert-icon'>
                                        <RandomIcon color={'#ffffff'} bgColor={'#343434'} />
                                    </div>
                                    <div className='alert-content'>
                                        <p>Profesional aleatorio: <span style={{ color: colores.colorSecundario }}>
                                            {(() => {
                                                const prof = citaActive.servicioActual?.profesional != null
                                                    ? (typeof citaActive.servicioActual.profesional === 'object' && citaActive.servicioActual.profesional?.nombre
                                                        ? citaActive.servicioActual.profesional.nombre
                                                        : (rdProfesionales.find(p => p && (String(p._id) === String(citaActive.servicioActual.profesional?._id || citaActive.servicioActual.profesional)))?.nombre))
                                                    : citaActive?.profesional?.nombre;
                                                return prof || '—';
                                            })()}
                                        </span></p>
                                    </div>
                                </div>
                            }
                            {
                                citaActive?.usuarioDelay !== "0" &&
                                <div className='alert-item client-delay'>
                                    <div className='alert-icon'>
                                        <DelayIcon color={'#ffffff'} bgColor={'#343434'} />
                                    </div>
                                    <div className='alert-content'>
                                        <p>Cliente con delay asociado: <span style={{ color: colores.colorSecundario }}>{citaActive?.usuarioDelay} {`${citaActive?.usuarioDelayType === 'time' ? 'min.' : '%'}`}</span></p>
                                    </div>
                                </div>
                            }
                            {
                                (() => {
                                    const profId = citaActive?.servicioActual?.profesional != null
                                        ? (typeof citaActive.servicioActual.profesional === 'object' ? (citaActive.servicioActual.profesional?._id || citaActive.servicioActual.profesional) : citaActive.servicioActual.profesional)
                                        : (citaActive?.profesional?._id || citaActive?.profesional);
                                    const profData = profId && rdProfesionales?.length ? rdProfesionales.find(p => p && String(p._id) === String(profId)) : null;
                                    const delay = profData?.delay ?? citaActive?.profesionalDelay;
                                    const delayType = profData?.delayType ?? citaActive?.profesionalDelayType;
                                    if (delay == null || delay === "" || delay === "0" || Number(delay) === 0) return null;
                                    return (
                                        <div className='alert-item prof-delay'>
                                            <div className='alert-icon'>
                                                <DelayIcon color={'#ffffff'} bgColor={'#343434'} />
                                            </div>
                                            <div className='alert-content'>
                                                <p>Profesional con delay asociado: <span style={{ color: colores.colorSecundario }}>{delay} {`${delayType === 'time' ? 'min.' : '%'}`}</span></p>
                                            </div>
                                        </div>
                                    );
                                })()
                            }
                            {
                                usuarioActivoResolved?.comentarios?.length > 0 &&
                                <div className='alert-item observaciones'>
                                    <div className='alert-icon'>
                                        <ObservacionesIcon color={'#ffffff'} />
                                    </div>
                                    <div className='alert-content'>
                                        <p>Observaciones del cliente:</p>
                                        {
                                            usuarioActivoResolved?.comentarios.map(comentario => (
                                                <p key={comentario._id}><span style={{ color: colores.colorSecundario }}>{comentario.texto}</span></p>
                                            ))
                                        }
                                    </div>
                                </div>
                            }
                            {
                                citaActive.pagada &&
                                <div className='alert-item pagado'>
                                    <div className='alert-icon'>
                                        <EuroIcon color={'#ffffff'} />
                                    </div>
                                    <div className='alert-content'>
                                        <p>Estado:
                                            <span className='ok-pagado' style={{ color: `#96F8D2` }}>
                                                Pagado <CheckIcon />
                                            </span>
                                        </p>
                                    </div>
                                </div>
                            }
                            {
                                citaActive.confirmada && citaActive.prepago && !citaActive.pagada &&
                                <div className='alert-item pagado'>
                                    <div className='alert-icon'>
                                        <EuroIcon color={'#ffffff'} />
                                    </div>
                                    <div className='alert-content'>
                                        <p>Estado:
                                            <span className='ok-pagado' style={{ color: `#FFD700` }}>
                                                Saldo cargado, pendiente cobro
                                            </span>
                                        </p>
                                    </div>
                                </div>
                            }
                            {
                                comentariosCita.length > 0 &&
                                <div className='alert-item comments'>
                                    <div className='alert-icon'>
                                        <CommentsFilledIcon color={'#ffffff'} background={'#343434'} />
                                    </div>
                                    <div className='alert-content'>
                                        <p>Comentarios de la reserva:</p>
                                        {
                                            (comentariosCita).map((comentario, index) => {
                                                if (!comentario.business) {
                                                    return <p key={index}><span style={{ color: colores.colorSecundario }}>{comentario.texto}</span></p>
                                                }
                                                return false;
                                            })
                                        }
                                        <div className='comments-respuesta'>
                                            <p>Respuesta:</p>
                                            {
                                                comentariosRespondidos &&
                                                <textarea
                                                    style={{
                                                        backgroundColor: `#343434`,
                                                        color: colores.colorSecundario
                                                    }}
                                                    value={txtComentario}
                                                    placeholder="Escribir comentario"
                                                    disabled={true}
                                                    onChange={(e) => setTxtComentario(e.target.value)}
                                                ></textarea>
                                            }
                                            {
                                                !comentariosRespondidos &&
                                                <>
                                                    <div className='respuesta-item'>
                                                        <div
                                                            className='check-row'
                                                            onClick={() => setRespuestaAutomatica(true)}
                                                        >
                                                            <div
                                                                className='respuesta-check'
                                                                style={{ backgroundColor: `#ffffff` }}
                                                            >
                                                                {
                                                                    respuestaAutomatica &&
                                                                    <div
                                                                        className='check-selected'
                                                                        style={{ backgroundColor: colores.colorPrincipal }}
                                                                    ></div>}
                                                            </div>
                                                            <div className='respuesta-text'>
                                                                <p>Respuesta automática</p>
                                                            </div>
                                                        </div>
                                                        <div className='botonera'>
                                                            <div
                                                                className='botonera-item'
                                                                style={{
                                                                    backgroundColor: colores.colorPrincipal,
                                                                    color: colores.colorSecundario
                                                                }}
                                                                onClick={(e) => respuestaAutomatica && setTxtComentario(e.target.innerText)}
                                                            ><FingerUpIcon color={colores.colorSecundario} />Ok, lo tenemos en cuenta, ¡gracias!</div>
                                                            <div
                                                                className='botonera-item down'
                                                                style={{
                                                                    backgroundColor: colores.colorSecundario,
                                                                    color: colores.colorPrincipal
                                                                }}
                                                                onClick={(e) => respuestaAutomatica && setTxtComentario(e.target.innerText)}
                                                            ><FingerDownIcon color={colores.colorPrincipal} />Lo siento, no podrá ser, ¡disculpa!</div>
                                                        </div>
                                                    </div>
                                                    <div className='respuesta-item'>
                                                        <div
                                                            className='check-row'
                                                            onClick={() => {
                                                                setTxtComentario('');
                                                                setRespuestaAutomatica(false);
                                                            }}
                                                        >
                                                            <div
                                                                className='respuesta-check'
                                                                style={{ backgroundColor: `#ffffff` }}
                                                            >
                                                                {
                                                                    !respuestaAutomatica &&
                                                                    <div
                                                                        className='check-selected'
                                                                        style={{ backgroundColor: colores.colorPrincipal }}
                                                                    ></div>
                                                                }
                                                            </div>
                                                            <div className='respuesta-text'>
                                                                <p>Respuesta personalizada</p>
                                                            </div>
                                                        </div>
                                                        <div className='text-area'>
                                                            <textarea
                                                                style={{
                                                                    backgroundColor: `#343434`,
                                                                    color: colores.colorSecundario
                                                                }}
                                                                value={txtComentario}
                                                                placeholder="Escribir comentario"
                                                                onChange={(e) => setTxtComentario(e.target.value)}
                                                            ></textarea>
                                                        </div>
                                                    </div>
                                                    <div
                                                        className='btn-responder'
                                                        style={{
                                                            backgroundColor: colores.colorPrincipal,
                                                            color: '#ffffff'
                                                        }}
                                                        onClick={() => sendRespuesta()}
                                                    >
                                                        <p>Enviar respuesta</p>
                                                    </div>
                                                </>
                                            }
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>
                    )}
                    </div>
                </div>
            </div>
            
        </>
    )
}
